import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getRequest, patchRequest } from "../../axios";
import { useNavigate, useParams } from "react-router-dom";
import { authUserData } from "../../utils/Helper";
import {
  Checkbox,
  Collapse,
  Form,
  Input,
  Spin,
  Table,
  Breadcrumb,
  Tooltip,
  Row,
  Col,
  Layout,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { useTranslation } from "react-i18next";
import { SuccessNotificationMsg } from "../../utils/Notifications";
import { ReactComponent as RupeesSign } from "../../image/RupeesSign.svg";
import { ReactComponent as Left } from "../../image/left.svg";

import { confirmAlert } from "react-confirm-alert";

const VendorBidRFQSteel = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const formRef = useRef();

  const VendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
  const [apiLoading, setapiLoading] = useState(false);
  const [data, setData] = useState([]);
  const [CategoryId, setCtaegoryTree] = useState();
  const vendorBidId = id ? atob(id) : null;

  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState([]);
  const [rfqnumber, setRFQNumber] = useState([]);
  const [rfqcurrency, setRFQCurrency] = useState([]);
  const [rfqfreight, setRFQFreight] = useState([]);
  const [rfqunloading, setRFQUnloading] = useState([]);
  const [rfqpricebasis, setRFQPriceBasis] = useState([]);
  const [rfqtransportInsurance, setRFQTransportInsurance] = useState([]);

  const [rfqopenorder, setRFQOpenOrder] = useState(false);
  const [rfqpricecap, setRFQPriceCap] = useState([]);
  const [trackingOfStages, setTrackingOfStages] = useState(0);

  const [currentStep, setCurrentStep] = useState(0);
  const [buyingPattern, setBuyingPattern] = useState("");

  const [showUnitRateOfCement, setShowUnitRateOfCement] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [hideR0, setHideR0] = useState(false);
  const [hideR1, setHideR1] = useState(false);
  const [summaryTableData, setSummaryTableData] = useState([]);
  const [summaryTableData2, setSummaryTableData2] = useState([]);

  const [summaryTableDataRevised, setSummaryTableDataRevised] = useState([]);
  const [summaryTableDataFinal, setSummaryTableDataFinal] = useState([]);

  const [resetMode, setResetMode] = useState(false);
  const [isFinalBid, setIsFinalBid] = useState(false);

  const [isFinalWhen, setIsFinalWhen] = useState({
    isFinalR: false,
    isFinalR1: false,
    isFinalR0: false,
  });
  const { Content } = Layout;
  const [averagePrices, setAveragePrices] = useState([]);
  const handleHideR0Change = (e) => {
    setHideR0(e.target.checked);
  };
  const handleHideR1Change = (e) => {
    setHideR1(e.target.checked);
  };
  const { Panel } = Collapse;
  const [amountsBySiteAndMaterial, setAmountsBySiteAndMaterial] = useState({});
  const [buyingPatternPayload, setBuyingPatternPayload] = useState(null);
  const [rfqDetails, setRfqDetails] = useState([]);
  const [winningRatio, setWinningRatio] = useState(null);
  const [lastFiveBid, setLastBid] = useState([]);
  const [winningArray, setWinningArray] = useState([]);

  const [initialBidDates, setInitialBidDates] = useState(null);
  const [revisedBidDates, setRevisedBidDates] = useState(null);
  const [finalBidDates, setFinalBidDates] = useState(null);
  const [tableSummary, setTableSummary] = useState(tableData);

  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const [diameterRows, setDiameterRows] = useState([]);

  useEffect(() => {
    if (isFirstLoad) {
      setIsFirstLoad(false);
    }
  }, [isFirstLoad]);

  const currentDate = (() => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, "0");
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const yyyy = today.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
  })();
  const [state, setState] = useState([]);
  const [rfqData, setRfqData] = useState({
    open_order: false,
    rfqamountcap: "",
    rfqtimelinecap: "",
    rfqopendeliverydate: "",
    rfqdeliverystartdate: "",
    rfqdeliveryenddate: "",
    rfqduedate: "",
    rfqpricecap: "",
  });

  const [showUnitRateOfFreight, setShowUnitRateOfFreight] = useState(false);

  const calculateUnitRateWithGst = (
    initialBidPriceUnitRate,
    freightRate,
    gstRate,
    gst_rate_freight,
    fieldName
  ) => {
    const unitRateWithGst =
      initialBidPriceUnitRate + initialBidPriceUnitRate * (gstRate / 100);
    const freightWithGst = freightRate + freightRate * (gst_rate_freight / 100);
    return unitRateWithGst + freightWithGst;
  };

  const calculateUnitRateWithGstRevised = calculateUnitRateWithGst;
  const calculateUnitRateWithGstFinal = calculateUnitRateWithGst;

  const handleInputChange = (e, siteId, materialType, fieldName) => {
    if (resetMode) {
      setResetMode(false);
    }

    const { value } = e.target;
    const numericValue = parseFloat(value) || 0;

    setTableData((prevData) => {
      const updatedData = prevData.map((record) => {
        if (record.isSubtotal) return record;

        if (record.siteId === siteId && record.material_type === materialType) {
          const freightRate = (() => {
            if (
              fieldName === "initial_bid_price_unit_rate_of_freight" ||
              fieldName === "revised_bid_price_unit_rate_of_freight" ||
              fieldName === "final_bid_price_unit_rate_of_freight"
            ) {
              return numericValue;
            } else {
              return fieldName === "initial_bid_price_unit_rate"
                ? record.initial_bid_price_unit_rate_of_freight
                : fieldName === "revised_bid_price_unit_rate"
                ? record.revised_bid_price_unit_rate_of_freight
                : fieldName === "final_bid_price_unit_rate"
                ? record.final_bid_price_unit_rate_of_freight
                : 0;
            }
          })();

          const unitRate = (() => {
            if (
              fieldName === "initial_bid_price_unit_rate" ||
              fieldName === "revised_bid_price_unit_rate" ||
              fieldName === "final_bid_price_unit_rate"
            ) {
              return numericValue;
            } else {
              return fieldName === "initial_bid_price_unit_rate_of_freight"
                ? record.initial_bid_price_unit_rate
                : fieldName === "revised_bid_price_unit_rate_of_freight"
                ? record.revised_bid_price_unit_rate
                : fieldName === "final_bid_price_unit_rate_of_freight"
                ? record.final_bid_price_unit_rate
                : 0;
            }
          })();

          const updatedUnitRateWithGst =
            fieldName === "revised_bid_price_unit_rate" ||
            fieldName === "revised_bid_price_unit_rate_of_freight"
              ? calculateUnitRateWithGstRevised(
                  unitRate,
                  freightRate,
                  record.gst_rate,
                  record.gst_rate_freight,
                  fieldName
                )
              : fieldName === "final_bid_price_unit_rate" ||
                fieldName === "final_bid_price_unit_rate_of_freight"
              ? calculateUnitRateWithGstFinal(
                  unitRate,
                  freightRate,
                  record.gst_rate,
                  record.gst_rate_freight,
                  fieldName
                )
              : calculateUnitRateWithGst(
                  unitRate,
                  freightRate,
                  record.gst_rate,
                  record.gst_rate_freight,
                  fieldName
                );

          const updatedRecord = {
            ...record,
            [fieldName]: numericValue,
            unit_rate_with_gst: updatedUnitRateWithGst,
          };

          const updatedRecordRevised = {
            ...record,
            [fieldName]: numericValue,
            unit_rate_with_gst_revised: updatedUnitRateWithGst,
          };
          const updatedRecordFinal = {
            ...record,
            [fieldName]: numericValue,
            unit_rate_with_gst_final: updatedUnitRateWithGst,
          };

          if (
            fieldName === "initial_bid_price_unit_rate" ||
            fieldName === "initial_bid_price_unit_rate_of_freight"
          ) {
            let unitRateWithFreight = unitRate + freightRate;
            updatedRecord.initial_bid_price_amount =
              unitRateWithFreight * record.material_total_quantity;
          } else if (
            fieldName === "revised_bid_price_unit_rate" ||
            fieldName === "revised_bid_price_unit_rate_of_freight"
          ) {
            let unitRateWithFreight = unitRate + freightRate;

            updatedRecordRevised.revised_bid_price_amount =
              unitRateWithFreight * record.material_total_quantity;
          } else if (
            fieldName === "final_bid_price_unit_rate" ||
            fieldName === "final_bid_price_unit_rate_of_freight"
          ) {
            let unitRateWithFreight = unitRate + freightRate;
            updatedRecordFinal.final_bid_price_amount =
              unitRateWithFreight * record.material_total_quantity;
          }

          return fieldName === "initial_bid_price_unit_rate" ||
            fieldName === "initial_bid_price_unit_rate_of_freight"
            ? updatedRecord
            : fieldName === "final_bid_price_unit_rate" ||
              fieldName === "final_bid_price_unit_rate_of_freight"
            ? updatedRecordFinal
            : updatedRecordRevised;
        }

        return record;
      });

      return updatedData;
    });

    setTableSummary((prevData) => {
      const updatedData = prevData.map((record) => {
        if (record.isSubtotal) return record;

        if (record.siteId === siteId && record.material_type === materialType) {
          const freightRate = (() => {
            if (
              fieldName === "initial_bid_price_unit_rate_of_freight" ||
              fieldName === "revised_bid_price_unit_rate_of_freight" ||
              fieldName === "final_bid_price_unit_rate_of_freight"
            ) {
              return numericValue;
            } else {
              return fieldName === "initial_bid_price_unit_rate"
                ? record.initial_bid_price_unit_rate_of_freight
                : fieldName === "revised_bid_price_unit_rate"
                ? record.revised_bid_price_unit_rate_of_freight
                : fieldName === "final_bid_price_unit_rate"
                ? record.final_bid_price_unit_rate_of_freight
                : 0;
            }
          })();

          const unitRate = (() => {
            if (
              fieldName === "initial_bid_price_unit_rate" ||
              fieldName === "revised_bid_price_unit_rate" ||
              fieldName === "final_bid_price_unit_rate"
            ) {
              return numericValue;
            } else {
              return fieldName === "initial_bid_price_unit_rate_of_freight"
                ? record.initial_bid_price_unit_rate
                : fieldName === "revised_bid_price_unit_rate_of_freight"
                ? record.revised_bid_price_unit_rate
                : fieldName === "final_bid_price_unit_rate_of_freight"
                ? record.final_bid_price_unit_rate
                : 0;
            }
          })();

          const updatedUnitRateWithGst = calculateUnitRateWithGst(
            unitRate,
            freightRate,
            record.gst_rate,
            record.gst_rate_freight,
            fieldName
          );

          const updatedRecord = {
            ...record,
            [fieldName]: numericValue,
            unit_rate_with_gst: updatedUnitRateWithGst,
          };

          if (
            fieldName === "initial_bid_price_unit_rate" ||
            fieldName === "initial_bid_price_unit_rate_of_freight"
          ) {
            let unitRateWithFreight = unitRate + freightRate;
            updatedRecord.initial_bid_price_amount =
              unitRateWithFreight * record.material_total_quantity;
          } else if (
            fieldName === "revised_bid_price_unit_rate" ||
            fieldName === "revised_bid_price_unit_rate_of_freight"
          ) {
            let unitRateWithFreight = unitRate + freightRate;
            updatedRecord.revised_bid_price_amount =
              unitRateWithFreight * record.material_total_quantity;
          } else if (
            fieldName === "final_bid_price_unit_rate" ||
            fieldName === "final_bid_price_unit_rate_of_freight"
          ) {
            let unitRateWithFreight = unitRate + freightRate;
            updatedRecord.final_bid_price_amount =
              unitRateWithFreight * record.material_total_quantity;
          }

          return updatedRecord;
        }

        return record;
      });

      return updatedData;
    });

    if (
      fieldName === "initial_bid_price_unit_rate" ||
      fieldName === "initial_bid_price_unit_rate_of_freight"
    ) {
      const newTableData = [...tableSummary];

      const materialTotals = {};
      newTableData.forEach((cityDetail) => {
        const key =
          cityDetail.material_wise_uom !== "Cubic Meter" &&
          cityDetail.material_type_name;

        if (!key) return;

        if (!materialTotals[key]) {
          materialTotals[key] = {
            material_type_name: key,
            total_weighted_price: 0,
            total_quantity: 0,
          };
        }

        const quantity = Number(cityDetail.material_total_quantity) || 0;

        let rates = 0;

        if (
          fieldName === "initial_bid_price_unit_rate" ||
          fieldName === "initial_bid_price_unit_rate_of_freight"
        ) {
          rates = [
            cityDetail.initial_bid_price_unit_rate +
              cityDetail.initial_bid_price_unit_rate_of_freight || 0,
            (cityDetail.revised_bid_price_unit_rate = 0),
            (cityDetail.final_bid_price_unit_rate = 0),
          ].filter((rate) => rate > 0);
        }

        if (
          fieldName === "initial_bid_price_unit_rate_of_freight" ||
          fieldName === "initial_bid_price_unit_rate"
        ) {
          rates = [
            cityDetail.initial_bid_price_unit_rate +
              cityDetail.initial_bid_price_unit_rate_of_freight || 0,
            (cityDetail.revised_bid_price_unit_rate_of_freight = 0),
            (cityDetail.final_bid_price_unit_rate_of_freight = 0),
          ].filter((rate) => rate > 0);
        }

        const pricePerUnit =
          rates.length > 0 ? rates.reduce((a, b) => a + b) : 0;
        const weightedPrice = pricePerUnit * quantity;

        materialTotals[key].total_weighted_price += weightedPrice;
        materialTotals[key].total_quantity += quantity;
      });

      const fattenData = Object.values(materialTotals).map((material) => {
        const { total_weighted_price, total_quantity } = material;

        const averagePriceMT = total_quantity
          ? total_weighted_price / total_quantity
          : 0;
        const averagePriceKG = averagePriceMT / 1000;
        const averagePriceBag = averagePriceKG * 50;

        return {
          ...material,
          averagePriceMT,
          averagePriceKG,
        };
      });

      setSummaryTableData2(fattenData);
    }
  };

  const calculateAverages = () => {
    let totalCost = 0;
    let totalQtyKg = 0;

    tableData.forEach((record) => {
      if (!record.city_id || !record.siteId || !record.material_type_name)
        return;
      const qtyMT = record.material_total_quantity || 0;
      const price =
        (record.initial_bid_price_unit_rate || 0) +
        (record.initial_bid_price_unit_rate_of_freight || 0);
      totalCost += price * qtyMT;
      totalQtyKg += qtyMT * 1000; // convert MT to KG
    });

    let averagePricePerKg = totalQtyKg ? totalCost / totalQtyKg : 0;
    let averagePriceMT = averagePricePerKg * 1000;
    let averagePriceBag = averagePricePerKg * 50;

    setAveragePrices([
      {
        averagePriceMT,
        averagePriceBag,
        averagePricePerKg,
      },
    ]);
  };

  useEffect(() => {
    calculateAverages();
  }, [tableData]);

  const handleUnitRateChange = (
    newUnitRate,
    siteId,
    materialType,
    cityId,
    isFreight = false
  ) => {
    setTableData((prevData) => {
      const updatedData = prevData.map((record) => {
        if (record.isSubtotal) {
          return record;
        }
        return record;
      });

      const siteSubtotal = updatedData.reduce(
        (acc, record) => {
          const totalUnitRate =
            record.siteName !== "Sub-Total"
              ? record.initial_bid_price_unit_rate +
                record.initial_bid_price_unit_rate_of_freight
              : 0;

          const totalWithoutGST =
            record.siteName !== "Sub-Total"
              ? totalUnitRate * record.material_total_quantity
              : 0;

          const gstAmount =
            record.siteName !== "Sub-Total"
              ? (totalWithoutGST * (record?.gst_rate || 0)) / 100
              : 0;

          const newGSTAmount =
            record.siteName !== "Sub-Total" &&
            record.initial_bid_price_unit_rate +
              (record.initial_bid_price_unit_rate * (record?.gst_rate || 0)) /
                100;
          const newGSTAmountForFreight =
            record.siteName !== "Sub-Total" &&
            record.initial_bid_price_unit_rate_of_freight +
              (record.initial_bid_price_unit_rate_of_freight *
                (record?.gst_rate_freight || 0)) /
                100;

          if (record.siteId === siteId) {
            acc.total_initial_bid_price_unit_rate += totalWithoutGST;

            acc.total_revised_bid_price_unit_rate +=
              (record.revised_bid_price_unit_rate +
                record.revised_bid_price_unit_rate_of_freight) *
                record.material_total_quantity || 0;

            acc.total_unit_rate_with_gst +=
              newGSTAmountForFreight + newGSTAmount || 0;

            acc.total_initial_bid_price_unit_rate_of_freight +=
              record.initial_bid_price_unit_rate_of_freight || 0;
          }
          return acc;
        },
        {
          total_initial_bid_price_unit_rate: 0,
          total_revised_bid_price_unit_rate: 0,
          total_final_bid_price_unit_rate: 0,
          total_unit_rate_with_gst: 0,
          total_initial_bid_price_unit_rate_of_freight: 0,
          totalFreight: 0,
        }
      );

      const cityTotal = updatedData.reduce(
        (cityAcc, record) => {
          const totalUnitRate =
            record.siteName !== "City-Total"
              ? record.initial_bid_price_unit_rate +
                record.initial_bid_price_unit_rate_of_freight
              : 0;
          const totalWithoutGST =
            record.siteName !== "City-Total"
              ? totalUnitRate * record.material_total_quantity
              : 0;
          const gstAmount =
            record.siteName !== "City-Total"
              ? (totalWithoutGST * (record?.gst_rate || 0)) / 100
              : 0;

          const newGSTAmount =
            record.siteName !== "Sub-Total" &&
            record.initial_bid_price_unit_rate +
              (record.initial_bid_price_unit_rate * (record?.gst_rate || 0)) /
                100;
          const newGSTAmountForFreight =
            record.siteName !== "Sub-Total" &&
            record.initial_bid_price_unit_rate_of_freight +
              (record.initial_bid_price_unit_rate_of_freight *
                (record?.gst_rate_freight || 0)) /
                100;

          if (record.city_id === cityId) {
            cityAcc.total_initial_bid_price_unit_rate += totalWithoutGST;

            cityAcc.total_revised_bid_price_unit_rate +=
              record.revised_bid_price_unit_rate +
                record.revised_bid_price_unit_rate_of_freight || 0;

            cityAcc.total_final_bid_price_unit_rate +=
              record.final_bid_price_unit_rate +
                record.final_bid_price_unit_rate_of_freight || 0;

            cityAcc.total_unit_rate_with_gst +=
              newGSTAmount + newGSTAmountForFreight || 0;

            cityAcc.totalFreight +=
              record.initial_bid_price_unit_rate_of_freight || 0;
          }
          return cityAcc;
        },
        {
          total_initial_bid_price_unit_rate: 0,
          total_revised_bid_price_unit_rate: 0,
          total_final_bid_price_unit_rate: 0,
          total_unit_rate_with_gst: 0,
          totalFreight: 0,
        }
      );

      const finalData = updatedData.map((record) => {
        if (record.siteId === siteId) {
          return {
            ...record,
            total_initial_bid_price_unit_rate:
              siteSubtotal.total_initial_bid_price_unit_rate,
            total_initial_bid_price_unit_rate_of_freight:
              siteSubtotal.total_initial_bid_price_unit_rate_of_freight,
            total_revised_bid_price_unit_rate:
              siteSubtotal.total_revised_bid_price_unit_rate,
            total_final_bid_price_unit_rate:
              siteSubtotal.total_final_bid_price_unit_rate,
            total_unit_rate_with_gst: siteSubtotal.total_unit_rate_with_gst,
            totalFreight: siteSubtotal.totalFreight,
          };
        }
        if (record.siteName === "City-Total") {
          if (record.city_id === cityId) {
            return {
              ...record,
              total_initial_bid_price_unit_rate:
                cityTotal.total_initial_bid_price_unit_rate,
              total_initial_bid_price_unit_rate_of_freight:
                cityTotal.totalFreight,
              total_revised_bid_price_unit_rate:
                cityTotal.total_revised_bid_price_unit_rate,
              total_final_bid_price_unit_rate:
                cityTotal.total_final_bid_price_unit_rate,
              total_unit_rate_with_gst: cityTotal.total_unit_rate_with_gst,
              totalFreight: cityTotal.totalFreight,
            };
          }
        }
        return record;
      });

      return finalData;
    });
  };

  const handleUnitRateR1Change = (
    newUnitRate,
    siteId,
    materialType,
    cityId
  ) => {
    setTableData((prevData) => {
      const updatedData = prevData.map((record) => {
        if (record.isSubtotal) {
          return record;
        }
        return record;
      });

      const siteSubtotal = updatedData.reduce(
        (acc, record) => {
          if (record.siteId === siteId) {
            acc.total_revised_bid_price_unit_rate +=
              (record.revised_bid_price_unit_rate +
                record.revised_bid_price_unit_rate_of_freight) *
                record.material_total_quantity || 0;

            acc.total_unit_rate_with_gst_revised +=
              record.unit_rate_with_gst_revised || 0;

            acc.total_revised_bid_price_unit_rate_of_freight +=
              (record.revised_bid_price_unit_rate +
                record.revised_bid_price_unit_rate_of_freight) *
                record.material_total_quantity || 0;
          }
          return acc;
        },
        {
          total_revised_bid_price_unit_rate: 0,
          total_unit_rate_with_gst_revised: 0,
          total_revised_bid_price_unit_rate_of_freight: 0, // Add this line
        }
      );

      // Calculate city total
      const cityTotal = updatedData.reduce(
        (cityAcc, record) => {
          if (record.city_id === cityId) {
            cityAcc.total_revised_bid_price_unit_rate +=
              (record.revised_bid_price_unit_rate +
                record.revised_bid_price_unit_rate_of_freight) *
                record.material_total_quantity || 0;

            cityAcc.total_unit_rate_with_gst_revised +=
              record.unit_rate_with_gst_revised !== undefined
                ? record.unit_rate_with_gst_revised
                : 0;

            cityAcc.total_revised_bid_price_unit_rate_of_freight +=
              record.revised_bid_price_unit_rate_of_freight *
              record.material_total_quantity;
          }
          return cityAcc;
        },
        {
          total_revised_bid_price_unit_rate: 0,
          total_unit_rate_with_gst_revised: 0,
          total_revised_bid_price_unit_rate_of_freight: 0, // Add this line
        }
      );

      const finalData = updatedData.map((record) => {
        if (record.siteId === siteId) {
          return {
            ...record,
            total_revised_bid_price_unit_rate:
              siteSubtotal.total_revised_bid_price_unit_rate,
            total_unit_rate_with_gst_revised:
              siteSubtotal.total_unit_rate_with_gst_revised,
            total_revised_bid_price_unit_rate_of_freight:
              siteSubtotal.total_revised_bid_price_unit_rate_of_freight, // Add this line
          };
        }

        if (record.siteName === "City-Total") {
          if (record.city_id === cityId) {
            return {
              ...record,

              total_revised_bid_price_unit_rate:
                cityTotal.total_revised_bid_price_unit_rate,

              total_unit_rate_with_gst_revised:
                cityTotal.total_unit_rate_with_gst_revised,

              total_revised_bid_price_unit_rate_of_freight:
                cityTotal.total_revised_bid_price_unit_rate_of_freight, // Add this line
            };
          }
        }
        return record;
      });

      return finalData;
    });
  };

  const handleUnitRateFinalChange = (
    newUnitRate,
    siteId,
    materialType,
    cityId
  ) => {
    setTableData((prevData) => {
      const updatedData = prevData.map((record) => {
        if (record.isSubtotal) {
          return record;
        }
        return record;
      });

      const siteSubtotal = updatedData.reduce(
        (acc, record) => {
          if (record.siteId === siteId) {
            acc.total_final_bid_price_unit_rate +=
              (record.final_bid_price_unit_rate +
                record.final_bid_price_unit_rate_of_freight) *
                record.material_total_quantity || 0;

            acc.total_unit_rate_with_gst_final +=
              record.unit_rate_with_gst_final || 0;

            acc.total_final_bid_price_unit_rate_of_freight +=
              record.final_bid_price_unit_rate_of_freight || 0; // Add this line
          }
          return acc;
        },
        {
          total_final_bid_price_unit_rate: 0,
          total_unit_rate_with_gst_final: 0,
          total_final_bid_price_unit_rate_of_freight: 0,
        }
      );

      // Calculate city total
      const cityTotal = updatedData.reduce(
        (cityAcc, record) => {
          if (record.city_id === cityId) {
            cityAcc.total_final_bid_price_unit_rate +=
              (record.final_bid_price_unit_rate +
                record.final_bid_price_unit_rate_of_freight) *
                record.material_total_quantity || 0;

            cityAcc.total_unit_rate_with_gst_final +=
              record.unit_rate_with_gst_final !== undefined
                ? record.unit_rate_with_gst_final
                : 0;

            cityAcc.total_final_bid_price_unit_rate_of_freight +=
              record.revised_bid_price_unit_rate_of_freight *
              record.material_total_quantity;
          }
          return cityAcc;
        },
        {
          total_final_bid_price_unit_rate: 0,
          total_unit_rate_with_gst_final: 0,
          total_final_bid_price_unit_rate_of_freight: 0, // Add this line
        }
      );

      const finalData = updatedData.map((record) => {
        if (record.siteId === siteId) {
          return {
            ...record,
            total_final_bid_price_unit_rate:
              siteSubtotal.total_final_bid_price_unit_rate,
            total_unit_rate_with_gst_final:
              siteSubtotal.total_unit_rate_with_gst_final,
            total_final_bid_price_unit_rate_of_freight:
              siteSubtotal.total_final_bid_price_unit_rate_of_freight,
          };
        }
        if (record.siteName === "City-Total") {
          if (record.city_id === cityId) {
            return {
              ...record,

              total_final_bid_price_unit_rate:
                cityTotal.total_final_bid_price_unit_rate,
              total_unit_rate_with_gst_final:
                cityTotal.total_unit_rate_with_gst_final,
              total_final_bid_price_unit_rate_of_freight:
                cityTotal.total_final_bid_price_unit_rate_of_freight, // Add this line
            };
          }
        }
        return record;
      });

      return finalData;
    });
  };

  const handleInputChangeDate = (e, siteId, materialType, fieldName) => {
    if (resetMode) {
      setResetMode(false);
    }

    const { value } = e.target;
    setTableData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_site_details: city.bid_rfq_site_details.map((site) => {
          if (site.site_id === siteId) {
            return {
              ...site,
              bid_rfq_material_details: site.bid_rfq_material_details.map(
                (material) => {
                  if (material.material_type === materialType) {
                    if (
                      [
                        "final_bid_price_unit_rate",
                        "revised_bid_price_unit_rate",
                        "initial_bid_price_date",
                      ].includes(fieldName)
                    ) {
                      const updatedMaterial = {
                        ...material,
                        [fieldName]: currentDate,
                        unit_rate_with_gst: calculateUnitRateWithGst(
                          currentDate,
                          material.material_total_quantity,
                          material.gst_rate
                        ),
                      };
                      return updatedMaterial;
                    } else {
                      const updatedMaterial = {
                        ...material,
                        [fieldName]: currentDate,
                      };
                      return updatedMaterial;
                    }
                  }
                  return material;
                }
              ),
            };
          }
          return site;
        }),
      }))
    );
  };

  const handleInputChangeFreight = (e, siteId, materialType) => {
    const { value } = e.target;

    setState((prevState) => ({
      ...prevState,
      bid_rfq_city_wise_detail: prevState.bid_rfq_city_wise_detail.map(
        (city) => ({
          ...city,
          bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
            site.site_id === siteId
              ? {
                  ...site,
                  bid_rfq_material_details: site.bid_rfq_material_details.map(
                    (material) =>
                      material.material_type === materialType
                        ? {
                            ...material,
                            initial_bid_price_unit_rate_of_freight: value,
                          }
                        : material
                  ),
                }
              : site
          ),
        })
      ),
    }));
  };

  const handleInputChangeUnitRateOfCementR1 = (e, siteId, materialType) => {
    const { value } = e.target;

    setState((prevState) => ({
      ...prevState,
      bid_rfq_city_wise_detail: prevState.bid_rfq_city_wise_detail.map(
        (city) => ({
          ...city,
          bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
            site.site_id === siteId
              ? {
                  ...site,
                  bid_rfq_material_details: site.bid_rfq_material_details.map(
                    (material) =>
                      material.material_type === materialType
                        ? { ...material, revised_bid_price_unit_rate: value }
                        : material
                  ),
                }
              : site
          ),
        })
      ),
    }));
  };
  const handleInputChangeUnitRateOfCementR = (e, siteId, materialType) => {
    const { value } = e.target;

    setState((prevState) => ({
      ...prevState,
      bid_rfq_city_wise_detail: prevState.bid_rfq_city_wise_detail.map(
        (city) => ({
          ...city,
          bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
            site.site_id === siteId
              ? {
                  ...site,
                  bid_rfq_material_details: site.bid_rfq_material_details.map(
                    (material) =>
                      material.material_type === materialType
                        ? { ...material, final_bid_price_unit_rate: value }
                        : material
                  ),
                }
              : site
          ),
        })
      ),
    }));
  };

  const handleInputChangeFreightR1 = (e, siteId, materialType) => {
    const { value } = e.target;

    setState((prevState) => ({
      ...prevState,
      bid_rfq_city_wise_detail: prevState.bid_rfq_city_wise_detail.map(
        (city) => ({
          ...city,
          bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
            site.site_id === siteId
              ? {
                  ...site,
                  bid_rfq_material_details: site.bid_rfq_material_details.map(
                    (material) =>
                      material.material_type === materialType
                        ? {
                            ...material,
                            revised_bid_price_unit_rate_of_freight: value,
                          }
                        : material
                  ),
                }
              : site
          ),
        })
      ),
    }));
  };
  const handleInputChangeFreightR = (e, siteId, materialType) => {
    const { value } = e.target;

    setState((prevState) => ({
      ...prevState,
      bid_rfq_city_wise_detail: prevState.bid_rfq_city_wise_detail.map(
        (city) => ({
          ...city,
          bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
            site.site_id === siteId
              ? {
                  ...site,
                  bid_rfq_material_details: site.bid_rfq_material_details.map(
                    (material) =>
                      material.material_type === materialType
                        ? {
                            ...material,
                            final_bid_price_unit_rate_of_freight: value,
                          }
                        : material
                  ),
                }
              : site
          ),
        })
      ),
    }));
  };
  const resetGSTValues = useCallback(() => {
    setTableData((prevData) =>
      prevData.map((item) => {
        if (item.material_type_name) {
          return {
            ...item,
          };
        }

        return item;
      })
    );
    setResetMode(true);
    setSummaryTableData((prevSummaryData) =>
      prevSummaryData?.map((city) => ({
        ...city,
        sites: city?.sites?.map((site) => ({
          ...site,
          totalAmountWithGst: 0,
          totalAmountWithoutGst: 0,
        })),
      }))
    );
  }, [setTableData, setResetMode]);

  const handleInputChangeUnitRateWIthGST = (e, siteId, materialType) => {
    const { value } = e.target;
    setData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_city_detail: city.bid_rfq_city_detail.map((site) =>
          site.site_id === siteId
            ? {
                ...site,
                material_details: site.material_details.map((material) =>
                  material.material_type === materialType
                    ? { ...material, unit_rate_with_gst: value }
                    : material
                ),
              }
            : site
        ),
      }))
    );
  };

  const handleInputChangeLQPForThisClient = (e, siteId, materialType) => {
    const { value } = e.target;

    setData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
          site.site_id === siteId
            ? {
                ...site,
                bid_rfq_material_details: site.bid_rfq_material_details.map(
                  (material) =>
                    material.material_type === materialType
                      ? { ...material, lqp_for_this_client: value }
                      : material
                ),
              }
            : site
        ),
      }))
    );
  };

  const handleInputChangeAnyLqp = (e, siteId, materialType) => {
    const { value } = e.target;
    setData((prevData) =>
      prevData.map((city) => ({
        ...city,
        bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
          site.site_id === siteId
            ? {
                ...site,
                bid_rfq_material_details: site.bid_rfq_material_details.map(
                  (material) =>
                    material.material_type === materialType
                      ? { ...material, lqp_for_this_any_client: value }
                      : material
                ),
              }
            : site
        ),
      }))
    );
  };
  const handleDateChange = (cityIndex, siteIndex, field, value) => {
    const newData = [...tableData];
    newData[cityIndex].bid_rfq_site_details[siteIndex][field] = value;
    setTableData(newData);
  };

  useEffect(() => {
    const getVendorWinningRatio = async () => {
      try {
        const response = await getRequest(
          `bid-rfq/${rfqDetails.vendor_id}/bid-rfq-winning-ratio-of-one-year/?company_id=${rfqDetails.company_id}`
        );

        if (response?.data?.success === true) {
          setWinningRatio(response.data.data.winning_ratio);

          const arrayOfObjects = Object.entries(response.data.data).map(
            ([key, value]) => ({ key, value })
          );

          setWinningArray(arrayOfObjects);
        }
      } catch (error) {
        console.error("Error fetching vendor winning ratio:", error);
      }
    };

    if (rfqDetails?.vendor_id && rfqDetails?.company_id) {
      getVendorWinningRatio();
    }
  }, [rfqDetails]);

  useEffect(() => {
    const getVendorFive = async () => {
      try {
        const response = await getRequest(
          `bid-rfq/${rfqDetails.vendor_id}/last-five-bid-results/?company_id=${rfqDetails.company_id}`
        );

        if (response?.data?.success === true) {
          let last = response?.data?.data;
          let lastReverse = last?.reverse();
          setLastBid(lastReverse);
        }
      } catch (error) {
        console.error("Error fetching vendor winning ratio:", error);
      }
    };

    if (rfqDetails?.vendor_id && rfqDetails?.company_id) {
      getVendorFive();
    }
  }, [winningRatio]);

useEffect(() => {
  const getVendorBidRFQ = async () => {
    setapiLoading(true);
    try {
      const response1 = await getRequest(
        `bid-rfq/${vendorBidId}/get-bid-rfq-city-wise/?vendor_id=${VendorId}`
      );
      const response = response1.data.data;

      const flatTableData = flattenGetResponseForTableData(response);
      setTableData(flatTableData);

      let cityTotals = {};
      let serialNumber = 0;
      let lastCityName = null;
      let lastSiteName = null;

      const fattenData = response.bid_rfq_city_wise_detail.flatMap((cityDetail, cityIndex) => {
        const siteMap = {};
        if (!cityTotals[cityDetail.city_id]) {
          cityTotals[cityDetail.city_id] = {
            total_initial_bid_price_unit_rate: 0,
            total_revised_bid_price_unit_rate: 0,
            total_initial_bid_price_unit_rate_of_freight: 0,
            total_revised_bid_price_unit_rate_of_freight: 0,
            total_material_total_quantity: 0,
            total_material_total_quantity_kg: 0,
            total_gst_rate: 0,
            total_unit_rate_with_gst: 0,
          };
        }

        const intermediateTotals = {};

        cityDetail.bid_rfq_site_details.forEach((siteDetail) => {
          const siteId = siteDetail.site_id;
          const seenSubCategories = new Map(); // Track sub-categories per material_type

          let siteSubtotal = 0;

          if (!siteMap[siteId]) {
            siteMap[siteId] = {
              ...siteDetail,
              bid_rfq_material_details: [],
              showSiteName: true,
              subtotal: {
                initial_bid_price_unit_rate: 0,
                initial_bid_price_unit_rate_of_freight: 0,
                revised_bid_price_unit_rate: 0,
                revised_bid_price_unit_rate_of_freight: 0,
                material_total_quantity: 0,
                material_total_quantity_by_kg: 0,
                gst_rate: 0,
                unit_rate_with_gst: 0,
                unit_rate_with_gst_revised: 0,
                unit_rate_with_gst_final: 0,
                total_initial_bid_price_unit_rate: 0,
                total_revised_bid_price_unit_rate: 0,
              },
            };
          }

          // Sort materials by material_type_sub_category and material_type
          const sortedMaterials = [...siteDetail.bid_rfq_material_details].sort((a, b) => {
            const subCatA = a.material_type_sub_category || "";
            const subCatB = b.material_type_sub_category || "";
            return subCatA.localeCompare(subCatB) || a.material_type - b.material_type;
          });

          sortedMaterials.forEach((materialDetail) => {
            const materialType = materialDetail.material_type;
            const materialSubCategory = materialDetail.material_type_sub_category || "";
            const rfqVendorDetail = siteDetail.rfq_vendor_detail;
            const materialKey = `${materialType}|${materialSubCategory}`;
            const showSubCategory = !seenSubCategories.has(materialKey);
            seenSubCategories.set(materialKey, true);

            const existingMaterial = siteMap[siteId].bid_rfq_material_details.find(
              (material) =>
                material.material_type === materialType &&
                material.material_type_sub_category === (showSubCategory ? materialSubCategory : "")
            );

            if (existingMaterial) {
              existingMaterial.material_total_quantity +=
                materialDetail.material_total_quantity || 0;
              existingMaterial.material_total_quantity_by_kg +=
                materialDetail.material_total_quantity_by_kg || 0;
              existingMaterial.gst_rate += materialDetail.gst_rate || 0;
              existingMaterial.initial_bid_price_unit_rate +=
                materialDetail.initial_bid_price_unit_rate || 0;
              existingMaterial.initial_bid_price_unit_rate_of_freight +=
                materialDetail.initial_bid_price_unit_rate_of_freight || 0;
              existingMaterial.revised_bid_price_unit_rate +=
                materialDetail.revised_bid_price_unit_rate || 0;
              existingMaterial.revised_bid_price_unit_rate_of_freight +=
                materialDetail.revised_bid_price_unit_rate_of_freight || 0;
              existingMaterial.unit_rate_with_gst += materialDetail.unit_rate_with_gst || 0;
              existingMaterial.unit_rate_with_gst_revised +=
                materialDetail.revised_unit_rate_with_gst || 0;
              existingMaterial.rfq_vendor_detail = rfqVendorDetail;
            } else {
              siteMap[siteId].bid_rfq_material_details.push({
                ...materialDetail,
                material_type_sub_category: showSubCategory ? materialSubCategory : "",
                rfq_vendor_detail: rfqVendorDetail,
              });
            }

            siteMap[siteId].subtotal.initial_bid_price_unit_rate +=
              materialDetail.initial_bid_price_unit_rate || 0;
            siteMap[siteId].subtotal.initial_bid_price_unit_rate_of_freight +=
              materialDetail.initial_bid_price_unit_rate_of_freight || 0;
            siteMap[siteId].subtotal.revised_bid_price_unit_rate +=
              materialDetail.revised_bid_price_unit_rate || 0;
            siteMap[siteId].subtotal.revised_bid_price_unit_rate_of_freight +=
              materialDetail.revised_bid_price_unit_rate_of_freight || 0;
            siteMap[siteId].subtotal.material_total_quantity +=
              materialDetail.material_total_quantity || 0;
            siteMap[siteId].subtotal.material_total_quantity_by_kg +=
              materialDetail.material_total_quantity_by_kg || 0;
            siteMap[siteId].subtotal.gst_rate += materialDetail.gst_rate || 0;
            siteMap[siteId].subtotal.unit_rate_with_gst += materialDetail.unit_rate_with_gst || 0;
            siteMap[siteId].subtotal.unit_rate_with_gst_revised +=
              materialDetail.revised_unit_rate_with_gst || 0;
            siteMap[siteId].subtotal.total_initial_bid_price_unit_rate +=
              (materialDetail.material_total_quantity || 0) *
              (materialDetail.initial_bid_price_unit_rate +
                materialDetail.initial_bid_price_unit_rate_of_freight || 0);
            siteMap[siteId].subtotal.total_revised_bid_price_unit_rate +=
              (materialDetail.material_total_quantity || 0) *
              (materialDetail.revised_bid_price_unit_rate +
                materialDetail.revised_bid_price_unit_rate_of_freight || 0);

            cityTotals[cityDetail.city_id].total_initial_bid_price_unit_rate +=
              materialDetail.initial_bid_price_unit_rate || 0;
            cityTotals[cityDetail.city_id].total_revised_bid_price_unit_rate +=
              materialDetail.revised_bid_price_unit_rate || 0;
            cityTotals[cityDetail.city_id].total_initial_bid_price_unit_rate_of_freight +=
              materialDetail.initial_bid_price_unit_rate_of_freight || 0;
            cityTotals[cityDetail.city_id].total_revised_bid_price_unit_rate +=
              materialDetail.revised_bid_price_unit_rate || 0;
            cityTotals[cityDetail.city_id].total_revised_bid_price_unit_rate_of_freight +=
              materialDetail.revised_bid_price_unit_rate_of_freight || 0;
            cityTotals[cityDetail.city_id].total_material_total_quantity +=
              materialDetail.material_total_quantity || 0;
            cityTotals[cityDetail.city_id].total_material_total_quantity_kg +=
              materialDetail.material_total_quantity_by_kg || 0;
            cityTotals[cityDetail.city_id].total_gst_rate += materialDetail.gst_rate || 0;
            cityTotals[cityDetail.city_id].total_unit_rate_with_gst +=
              materialDetail.unit_rate_with_gst || 0;
            cityTotals[cityDetail.city_id].total_unit_rate_with_gst_revised +=
              materialDetail.unit_rate_with_gst_revised || 0;

            const unitRate = materialDetail.initial_bid_price_unit_rate || 0;
            const totalQtyKg = materialDetail.material_total_quantity_by_kg || 0;
            const materialTotal = unitRate * totalQtyKg;
            siteSubtotal += materialTotal;
            intermediateTotals[siteId] = (intermediateTotals[siteId] || 0) + materialTotal;
          });
        });

        const siteRows = Object.values(siteMap).flatMap((site, siteIndex) => {
          const materialRows = site.bid_rfq_material_details.map((material) => {
            const isCityChanged = lastCityName !== cityDetail.city_name;
            const isSiteChanged = lastSiteName !== site.site_name;

            const siteInitialBidPrice =
              site.subtotal.material_total_quantity_by_kg *
              site.subtotal.initial_bid_price_unit_rate;

            if (isCityChanged) {
              serialNumber++;
              lastCityName = cityDetail.city_name;
            }

            if (isSiteChanged) {
              lastSiteName = site.site_name;
            }

            const qtyKg = material.material_total_quantity_by_kg || 0;
            const unitRate = material.initial_bid_price_unit_rate || 0;
            const materialTotal =
              (material.material_total_quantity_by_kg || 0) *
              (material.initial_bid_price_unit_rate || 0);

            intermediateTotals[site.site_id] =
              (intermediateTotals[site.site_id] || 0) + materialTotal;

            return {
              sr_no: isCityChanged ? serialNumber : null,
              city_id: cityDetail.city_name,
              city_name: isCityChanged ? cityDetail.city_name || null : null,
              site_name: isSiteChanged ? site.site_name || null : null,
              siteId: site.site_id,
              material_type_name: material.material_type_name || "",
              material_type_sub_category: material.material_type_sub_category || "",
              material_wise_uom: material.material_wise_uom || "",
              material_wise_uom_id: material.unit_of_measurement,
              material_type: material.material_type || null,
              material_total_quantity: material.material_total_quantity || 0,
              material_total_quantity_by_kg: material.material_total_quantity_by_kg || 0,
              gst_rate: material.gst_rate || 0,
              gst_rate_freight: material.gst_rate_freight || 0,
              initial_bid_price_unit_rate: material.initial_bid_price_unit_rate || 0,
              initial_bid_price_amount:
                material.initial_bid_price_unit_rate * material.material_total_quantity +
                material.initial_bid_price_unit_rate_of_freight * material.material_total_quantity || 0,
              initial_bid_price_unit_rate_of_freight:
                material.initial_bid_price_unit_rate_of_freight || 0,
              revised_bid_price_unit_rate: material.revised_bid_price_unit_rate || 0,
              revised_bid_price_amount:
                material.revised_bid_price_unit_rate * material.material_total_quantity +
                material.revised_bid_price_unit_rate_of_freight * material.material_total_quantity || 0,
              revised_bid_price_unit_rate_of_freight:
                material.revised_bid_price_unit_rate_of_freight || 0,
              final_bid_price_unit_rate: material.final_bid_price_unit_rate,
              final_bid_price_amount:
                material.final_bid_price_unit_rate * material.material_total_quantity +
                material.final_bid_price_unit_rate_of_freight * material.material_total_quantity || 0,
              final_bid_price_unit_rate_of_freight:
                material.final_bid_price_unit_rate_of_freight,
              unit_rate_with_gst: material.unit_rate_with_gst || 0,
              unit_rate_with_gst_revised: material.revised_unit_rate_with_gst || 0,
              rfq_vendor_detail: material.rfq_vendor_detail,
              initial_bid_price_date: material.initial_bid_price_date,
              revised_bid_price_date: material.revised_bid_price_date,
              final_bid_price_date: material.final_bid_price_date,
              rfq_material_detail: material.rfq_material_detail,
              bid_rfq_id: material.bid_rfq_id || null,
              is_initial_bid: material?.is_initial_bid,
              is_revised_bid: material?.is_revised_bid,
              is_final_bid: material?.is_final_bid,
            };
          });

          let materialTotal = 0;
          const qty = site.subtotal.material_total_quantity || 0;
          const qtyKg = site.subtotal.material_total_quantity_by_kg || 0;
          materialTotal += qty * qtyKg;
          intermediateTotals[site.site_id] =
            (intermediateTotals[site.site_id] || 0) + materialTotal;

          materialRows.push({
            key: `${cityIndex}-${siteIndex}-SubTotal`,
            siteName: "Sub-Total",
            siteId: site.site_id,
            qty: site.subtotal.material_total_quantity,
            qty_kg: site.subtotal.material_total_quantity_by_kg,
            total_initial_bid_price_unit_rate: site.subtotal.total_initial_bid_price_unit_rate || 0,
            total_initial_bid_price_unit_rate_of_freight:
              site.subtotal.initial_bid_price_unit_rate_of_freight,
            total_revised_bid_price_unit_rate: site.subtotal.total_revised_bid_price_unit_rate,
            total_revised_bid_price_unit_rate_of_freight:
              site.subtotal.revised_bid_price_unit_rate_of_freight,
            total_unit_rate_with_gst: site.subtotal.unit_rate_with_gst,
            total_unit_rate_with_gst_revised: site.subtotal.unit_rate_with_gst_revised,
            total_unit_rate_with_gst_final: site.subtotal.unit_rate_with_gst_final,
          });

          return materialRows;
        });

        const cityId = [...new Set(siteRows.map((row) => row.city_id))].join("");

        const totalQty = siteRows.reduce(
          (acc, row) => acc + (row.material_total_quantity || 0),
          0
        );
        const totalQtyInKg = siteRows.reduce(
          (acc, row) => acc + (row.material_total_quantity_by_kg || 0),
          0
        );

        const totalInitialBidPrice = siteRows.reduce(
          (acc, row) => acc + (row.total_initial_bid_price_unit_rate || 0),
          0
        );

        const totalInitialBidFreightPrice = siteRows.reduce(
          (acc, row) => acc + (row.total_initial_bid_price_unit_rate_of_freight || 0),
          0
        );

        const totalRevisedBidPrice = siteRows.reduce(
          (acc, row) => acc + (row.total_revised_bid_price_unit_rate || 0),
          0
        );
        const totalRevisedBidFreightPrice = siteRows.reduce(
          (acc, row) => acc + (row.total_revised_bid_price_unit_rate_of_freight || 0),
          0
        );

        const totalInitialUnitRateGST = siteRows.reduce(
          (acc, row) => acc + (row.total_unit_rate_with_gst || 0),
          0
        );

        const totalRevisedUnitRateGST = siteRows.reduce(
          (acc, row) => acc + (row.total_unit_rate_with_gst_revised || 0),
          0
        );

        const totalFinalUnitRateGST = siteRows.reduce(
          (acc, row) => acc + (row.total_unit_rate_with_gst_final || 0),
          0
        );

        siteRows.push({
          key: `city-${cityIndex}-Total`,
          siteName: "City-Total",
          city_id: cityId,
          qty: totalQty,
          qty_kg: totalQtyInKg,
          total_initial_bid_price_unit_rate: totalInitialBidPrice,
          total_initial_bid_price_unit_rate_of_freight: totalInitialBidFreightPrice,
          total_revised_bid_price_unit_rate: totalRevisedBidPrice,
          total_revised_bid_price_unit_rate_of_freight: totalRevisedBidFreightPrice,
          total_unit_rate_with_gst: totalInitialUnitRateGST,
          total_unit_rate_with_gst_revised: totalRevisedUnitRateGST,
          total_unit_rate_with_gst_final: totalFinalUnitRateGST,
        });

        return siteRows;
      });

      setTableSummary(fattenData);

      if (response?.bid_rfq_city_wise_detail) {
        let initialDates = null;
        let revisedDates = null;
        let finalDates = null;

        const firstCity = response.bid_rfq_city_wise_detail[0];
        if (firstCity) {
          const firstSite = firstCity.bid_rfq_site_details[0];
          if (firstSite) {
            const firstMaterial = firstSite.bid_rfq_material_details[0].diameter_details[0];
            if (firstMaterial) {
              initialDates = firstMaterial.initial_bid_price_date || null;
              revisedDates = firstMaterial.revised_bid_price_date || null;
              finalDates = firstMaterial.final_bid_price_date || null;
            }
          }
        }

        setInitialBidDates(initialDates);
        setRevisedBidDates(revisedDates);
        setFinalBidDates(finalDates);
      }

      setCompanyName(response.company);
      if (
        response.bid_rfq_city_wise_detail[0].bid_rfq_site_details[0]
          .bid_rfq_material_details[0].diameter_details[0]
          .initial_bid_price_date !== null
      ) {
        setHideR1(false);
        setCurrentStep(1);
        resetGSTValues();
      }
      if (
        response.bid_rfq_city_wise_detail[0].bid_rfq_site_details[0]
          .bid_rfq_material_details[0].diameter_details[0]
          .revised_bid_price_date !== null
      ) {
        setHideR1(false);
        setCurrentStep(2);
        resetGSTValues();
      }
      setRfqDetails(response);
      setRFQNumber(response.rfq_number);
      setRFQCurrency(response.currency_name);
      setRFQPriceBasis(response.price_basis);
      setRFQFreight(response.freight);
      setRFQUnloading(response.unloading);
      setRFQTransportInsurance(response.transport_insurance);
      setRFQOpenOrder(response.open_order);
      setRFQPriceCap(response.price_cap);
      setRfqData({
        open_order: response.open_order,
        rfqamountcap: response.amount_cap,
        rfqtimelinecap: response.timeline_cap,
        rfqopendeliverydate: response.delivery_date,
        rfqdeliverystartdate: response.delivery_start_date,
        rfqdeliveryenddate: response.delivery_end_date,
        rfqduedate: response.rfq_due_date,
        rfqpricecap: response.price_cap,
      });
      setState((prevState) => ({
        ...prevState,
        bid_rfq_city_wise_detail: response.bid_rfq_city_wise_detail,
      }));
      const buying_pattern = response.buying_pattern;
      setBuyingPatternPayload(buying_pattern);
      setBuyingPattern(buying_pattern);
      if (buying_pattern === "Unit Rate of Cement excluding Freight") {
        setShowUnitRateOfCement(true);
        setShowUnitRateOfFreight(true);
      } else if (buying_pattern === "Unit Rate of Cement including Freight") {
        setShowUnitRateOfCement(true);
        setShowUnitRateOfFreight(false);
      } else if (buying_pattern === "Total Unit Rate") {
        setShowUnitRateOfCement(false);
        setShowUnitRateOfFreight(true);
      }
    } catch (error) {
      console.error("Error:", error);
      setapiLoading(false);
    } finally {
      setapiLoading(false);
    }
  };
  getVendorBidRFQ();
}, [vendorBidId]);
  const hideR1Columns = hideR1 ? [] : {};
  const calculateSubtotals = (tableData) => {
    let siteSubtotals = {};
    let grandTotalCement = 0;
    let grandTotalFreight = 0;

    tableData.forEach((record) => {
      if (!record.isSubtotal) {
        const siteId = record.siteId;
        if (!siteSubtotals[siteId]) {
          siteSubtotals[siteId] = {
            totalCement: 0,
            totalFreight: 0,
          };
        }

        siteSubtotals[siteId].totalCement += Number(
          record.initial_bid_price_unit_rate || 0
        );
        siteSubtotals[siteId].totalFreight += Number(
          record.initial_bid_price_unit_rate_of_freight || 0
        );
        grandTotalCement += Number(record.initial_bid_price_unit_rate || 0);
        grandTotalFreight += Number(
          record.initial_bid_price_unit_rate_of_freight || 0
        );
      }
    });

    return { grandTotalCement, grandTotalFreight, siteSubtotals };
  };

  const { grandTotalCement, grandTotalFreight, siteSubtotals } =
    calculateSubtotals(tableData);

  function flattenBidData(response) {
    const rows = [];
    let sr = 1;
    response.data.bid_rfq_city_wise_detail.forEach((city) => {
      city.bid_rfq_site_details.forEach((site) => {
        site.bid_rfq_material_details.forEach((material) => {
          material.diameter_details.forEach((dia, diaIdx) => {
            rows.push({
              sr: sr,
              city_name: city.city_name,
              site_name: site.site_name,
              material_type_name: material.material_type_name,
              uom: material.material_wise_uom,
              diameter: dia.diameter_size + " MM",
              quantity: dia.quantity,
              unit_rate: dia.unit_rate || "",
              gst_rate: material.gst_rate || 0,
              cityRowSpan: diaIdx === 0 ? material.diameter_details.length : 0,
              siteRowSpan: diaIdx === 0 ? material.diameter_details.length : 0,
              materialRowSpan:
                diaIdx === 0 ? material.diameter_details.length : 0,
              uomRowSpan: diaIdx === 0 ? material.diameter_details.length : 0,
            });
          });
          sr++;
        });
      });
    });
    return rows;
  }

  function flattenBidDataForTable(rfqDetails) {
    const rows = [];
    let sr = 1;
    rfqDetails.bid_rfq_city_wise_detail.forEach((city) => {
      city.bid_rfq_site_details.forEach((site) => {
        site.bid_rfq_material_details.forEach((material) => {
          material.diameter_details.forEach((dia, diaIdx) => {
            rows.push({
              sr: sr,
              city_name: city.city_name,
              site_id: site.site_id,
              site_name: site.site_name,
              material_type_name: material.material_type_name,
              material_type: material.material_type,
              uom: material.material_wise_uom,
              unit_of_measurement: material.unit_of_measurement,
              diameter: dia.diameter_id,
              diameter_size: dia.diameter_size,
              quantity: dia.quantity,
              unit_rate: dia.unit_rate || "",
              gst_rate: material.gst_rate || 0,
              cityRowSpan: diaIdx === 0 ? material.diameter_details.length : 0,
              siteRowSpan: diaIdx === 0 ? material.diameter_details.length : 0,
              materialRowSpan:
                diaIdx === 0 ? material.diameter_details.length : 0,
              uomRowSpan: diaIdx === 0 ? material.diameter_details.length : 0,
              rfq_material_detail: material.rfq_material_detail,
            });
          });
          sr++;
        });
      });
    });
    return rows;
  }

function flattenGetResponseForTableData(getResponse) {
  const flatRows = [];
  if (!getResponse?.bid_rfq_city_wise_detail) return flatRows;
  let sr = 1;
  getResponse.bid_rfq_city_wise_detail.forEach((city) => {
    const city_name = city.city_name;
    city.bid_rfq_site_details.forEach((site) => {
      const site_id = site.site_id;
      const site_name = site.site_name;
      const seenSubCategories = new Map(); // Track sub-categories per material_type

      // Sort materials by material_type_sub_category and then material_type
      const sortedMaterials = [...site.bid_rfq_material_details].sort((a, b) => {
        const subCatA = a.material_type_sub_category || "";
        const subCatB = b.material_type_sub_category || "";
        return subCatA.localeCompare(subCatB) || a.material_type - b.material_type;
      });

      sortedMaterials.forEach((material) => {
        const {
          rfq_material_detail,
          material_type_name,
          material_type,
          material_total_quantity,
          material_total_quantity_by_kg,
          gst_rate,
          gst_rate_freight,
          id,
          material_wise_uom,
          unit_of_measurement,
          initial_bid_price_unit_rate,
          initial_bid_price_unit_rate_of_freight,
          revised_bid_price_unit_rate,
          revised_bid_price_unit_rate_of_freight,
          final_bid_price_unit_rate,
          final_bid_price_unit_rate_of_freight,
          initial_bid_amount_with_gst,
          initial_bid_amount_without_gst,
          revised_bid_amount_with_gst,
          revised_bid_amount_without_gst,
          final_bid_amount_with_gst,
          final_bid_amount_without_gst,
          unit_rate_with_gst,
          is_inital_final_bid,
          is_revised_final_bid,
          is_final_final_bid,
          is_initial_bid,
          is_revised_bid,
          is_final_bid,
          diameter_details,
          material_type_sub_category,
          initial_bid_price_date,
          revised_bid_price_date,
          final_bid_price_date,
        } = material;

        const materialKey = `${material_type}|${material_type_sub_category || ""}`;
        const showSubCategory = !seenSubCategories.has(materialKey);
        seenSubCategories.set(materialKey, true);

        if (Array.isArray(diameter_details)) {
          diameter_details.forEach((dia) => {
            flatRows.push({
              city_name,
              site_id,
              site_name,
              rfq_material_detail,
              material_type_name,
              material_type,
              material_total_quantity,
              material_total_quantity_by_kg,
              gst_rate,
              gst_rate_freight,
              id,
              material_wise_uom,
              unit_of_measurement,
              initial_bid_price_unit_rate,
              initial_bid_price_unit_rate_of_freight,
              revised_bid_price_unit_rate,
              revised_bid_price_unit_rate_of_freight,
              final_bid_price_unit_rate,
              final_bid_price_unit_rate_of_freight,
              initial_bid_amount_with_gst,
              initial_bid_amount_without_gst,
              revised_bid_amount_with_gst,
              revised_bid_amount_without_gst,
              final_bid_amount_with_gst,
              final_bid_amount_without_gst,
              unit_rate_with_gst,
              is_inital_final_bid,
              is_revised_final_bid,
              is_final_final_bid,
              is_initial_bid,
              is_revised_bid,
              is_final_bid,
              material_type_sub_category: showSubCategory ? material_type_sub_category || "" : "",
              diameter_id: dia.diameter_id,
              diameter: dia.diameter_value,
              diameter_uom: dia.diameter_uom,
              quantity: dia.quantity,
              uom: dia.diameter_uom || material.material_wise_uom,
              initial_bid_price_date,
              revised_bid_price_date,
              final_bid_price_date,
              ...dia,
              sr,
            });
          });
        }
      });
    });
    sr++;
  });

  return flatRows;
}


  function buildPayloadFromTableData(
    tableData,
    vendor,
    is_final_bid_price,
    bid_buying_pattern
  ) {
    const groupBy = (arr, key) =>
      arr.reduce((acc, item) => {
        const k = item[key];
        if (!acc[k]) acc[k] = [];
        acc[k].push(item);
        return acc;
      }, {});

    const cities = groupBy(tableData, "city_name");
    return {
      vendor,
      is_final_bid_price,
      bid_buying_pattern,
      bid_rfq_city_wise_detail: Object.entries(cities).map(
        ([city_name, cityRows]) => {
          const sites = groupBy(cityRows, "site_id");
          return {
            city_name,
            bid_rfq_site_details: Object.entries(sites).map(
              ([site_id, siteRows]) => {
                const materials = groupBy(siteRows, "material_type");
                return {
                  site_id: Number(site_id),
                  site_name: siteRows[0].site_name,
                  bid_rfq_material_details: Object.entries(materials).map(
                    ([material_type, materialRows], index) => {
                      let rfq_material_detail =
                        materialRows[0].rfq_material_detail;
                      if (!Array.isArray(rfq_material_detail))
                        rfq_material_detail = [rfq_material_detail];
                      const gst_rate = Number(materialRows[0].gst_rate) || 0;
                      const gst_rate_freight =
                        Number(materialRows[0].gst_rate_freight) || 0;

                      const totalQuantity = materialRows.reduce(
                        (sum, row) => sum + (Number(row.quantity) || 0),
                        0
                      );
                      const unitOfMeasurement =
                        materialRows[0]?.unit_of_measurement;

                      const totalQuantityByKg = materialRows.reduce(
                        (sum, row) => {
                          const qty = Number(row.quantity) || 0;
                          if (unitOfMeasurement === 1) {
                            return sum + qty * 1000;
                          } else {
                            return sum + qty * 1;
                          }
                        },
                        0
                      );
                      return {
                        rfq_material_detail,
                        material_type_name: materialRows[0]?.material_type_name,
                        material_type: Number(material_type),
                        material_total_quantity: totalQuantity,
                        // material_total_quantity_by_kg: totalQuantityByKg,
                        material_total_quantity_by_kg:
                          Number(materialRows[0].unit_of_measurement) === 5
                            ? totalQuantity * 1000
                            : totalQuantity,

                        gst_rate: gst_rate,
                        gst_rate_freight: Number(
                          materialRows[0].gst_rate_freight
                        ),

                        unit_of_measurement: Number(
                          materialRows[0].unit_of_measurement
                        ),

                        // is_inital_final_bid: !!materialRows[0].is_inital_final_bid,
                        // is_revised_final_bid: !!materialRows[0].is_revised_final_bid,
                        // is_final_final_bid: !!materialRows[0].is_final_final_bid,
                        // is_initial_bid: !!materialRows[0].is_initial_bid,
                        diameter_details: materialRows.map((row) => {
                          const unitRate =
                            Number(row.initial_bid_price_unit_rate) || 0;
                          const freight =
                            Number(
                              row.initial_bid_price_unit_rate_of_freight
                            ) || 0;
                          const quantity = Number(row.quantity) || 0;
                          const amountWithoutGst =
                            (unitRate + freight) * quantity;
                          const unitRateGst =
                            unitRate + unitRate * (gst_rate / 100);
                          const freightGst =
                            freight + freight * (gst_rate_freight / 100);
                          const amountWithGst =
                            unitRateGst * quantity + freightGst * quantity;
                          const unitRateWithGst = unitRateGst + freightGst;

                          const unitRateRevised =
                            Number(row.revised_bid_price_unit_rate) || 0;
                          const freightRevised =
                            Number(
                              row.revised_bid_price_unit_rate_of_freight
                            ) || 0;
                          const unitRateGstRevised =
                            unitRateRevised +
                            unitRateRevised * (gst_rate / 100);
                          const freightGstRevised =
                            freightRevised +
                            freightRevised * (gst_rate_freight / 100);
                          const amountWithGstRevised =
                            unitRateGstRevised * quantity +
                            freightGstRevised * quantity;

                          const unitRateFinal =
                            Number(row.final_bid_price_unit_rate) || 0;
                          const freightFinal =
                            Number(row.final_bid_price_unit_rate_of_freight) ||
                            0;
                          const unitRateGstFinal =
                            unitRateFinal + unitRateFinal * (gst_rate / 100);
                          const freightGstFinal =
                            freightFinal +
                            freightFinal * (gst_rate_freight / 100);
                          const amountWithGstFinal =
                            unitRateGstFinal * quantity +
                            freightGstFinal * quantity;

                          return {
                            id: row.id === null ? null : row.id,
                            diameter_id: row.diameter_id,
                            quantity: quantity,
                            initial_bid_price_unit_rate: unitRate,
                            initial_bid_price_unit_rate_of_freight: freight,
                            initial_bid_amount_without_gst:
                              (unitRate + freight) * quantity,
                            initial_bid_amount_with_gst: amountWithGst,
                            unit_rate_with_gst: unitRateWithGst,
                            initial_bid_price_unit_rate_of_freight: freight,
                            is_initial_final_bid: isFinalWhen.isFinalR0,
                            is_initial_bid:
                              initialBidDates === null
                                ? true
                                : row.is_initial_bid,
                            revised_bid_price_unit_rate: Number(
                              row.revised_bid_price_unit_rate
                            ),
                            revised_bid_price_unit_rate_of_freight: Number(
                              row.revised_bid_price_unit_rate_of_freight
                            ),
                            revised_bid_amount_with_gst: amountWithGstRevised,
                            revised_bid_amount_without_gst:
                              ((Number(row.revised_bid_price_unit_rate) || 0) +
                                (Number(
                                  row.revised_bid_price_unit_rate_of_freight
                                ) || 0)) *
                              (Number(row.quantity) || 0),
                            is_revised_final_bid: isFinalWhen.isFinalR1,
                            is_revised_bid:
                              revisedBidDates === null && initialBidDates
                                ? true
                                : row.is_revised_bid,
                            final_bid_price_unit_rate: Number(
                              row.final_bid_price_unit_rate
                            ),
                            final_bid_price_unit_rate_of_freight: Number(
                              row.final_bid_price_unit_rate_of_freight
                            ),
                            final_bid_amount_with_gst: amountWithGstFinal,
                            final_bid_amount_without_gst:
                              ((Number(row.final_bid_price_unit_rate) || 0) +
                                (Number(
                                  row.final_bid_price_unit_rate_of_freight
                                ) || 0)) *
                              (Number(row.quantity) || 0),
                            is_final_final_bid: isFinalWhen.isFinalR,
                            is_final_bid:
                              revisedBidDates && initialBidDates
                                ? true
                                : row.is_final_bid,
                          };
                        }),
                      };
                    }
                  ),
                };
              }
            ),
          };
        }
      ),
    };
  }

  const getColumns = () => {
    const columns = [
      {
        title: "Sr.",
        dataIndex: "sr_no",
        key: "sr_no",
        width: 50,
        fixed: "left",
      },
      {
        title: "City",
        dataIndex: "city_name",
        key: "city_name",
        width: 120,
        fixed: "left",
      },
      {
        title: "Site",
        dataIndex: "site_name",
        key: "site_name",
        width: 120,
        fixed: "left",
        render: (text, record) => {
          if (record?.site_name) {
            return <div className="normal-field">{record.site_name}</div>;
          } else if (record?.siteName === "Sub-Total") {
            return (
              <div className="subtotal1" style={{ textAlign: "center" }}>
                {"Sub Total"}
              </div>
            );
          } else if (record?.siteName === "City-Total") {
            return (
              <div className="citytotal2" style={{ textAlign: "center" }}>
                {"City Total"}
              </div>
            );
          } else {
            return null;
          }
        },
      },

      {
        title: "Material Type",
        dataIndex: "material_type_name",
        key: "material_type_name",
        width: 130,
        fixed: "left",
      },

      {
        title: "Qty.",
        dataIndex: "material_total_quantity",
        key: "material_total_quantity",
        align: "right",
        width: 60,
        fixed: "left",
        render: (text, record) => {
          if (record?.material_total_quantity) {
            return (
              <div style={{ marginRight: "10px" }}>
                {record.material_total_quantity}
              </div>
            );
          } else if (record.siteName === "Sub-Total" && record?.qty) {
            return null;
          } else if (record.siteName === "City-Total" && record?.qty) {
            return null;
          } else {
            return null;
          }
        },
      },

      {
        title: "UoM",
        dataIndex: "material_wise_uom",
        key: "material_wise_uom",
        width: 80,
        render: (text) => text,
      },
      {
        title: "Diameter",
        dataIndex: "diameter",
        width: 80,
        render: (text, row) =>
          text
            ? `${text} ${(row.diameter_uom || "").toUpperCase()}`.trim()
            : "",
      },
    ].filter(Boolean);

    return columns.map((col) => ({
      ...col,
      filterDropdown: col.filterDropdown || null,
    }));
  };

  const columns = getColumns();

  const columns2 = [
    {
      title: "City Name",
      dataIndex: "city_name",
      key: "city_name",
      render: (text, record) => <span>{record.city_name}</span>,
    },
    {
      title: "Site Name",
      dataIndex: "site_name",
      key: "site_name",
      render: (text, record) => (
        <div>
          {record.bid_rfq_site_details.map((site) => (
            <Input
              disabled
              key={site.site_id}
              value={site.site_name}
              className="InputItem"
            />
          ))}
        </div>
      ),
    },
    {
      title: "Amount With GST",
      dataIndex: "amount_with_gst",
      key: "amount_with_gst",
      render: (text, record) => (
        <div>
          {record.bid_rfq_site_details.map((site) => (
            <div key={site?.site_id}></div>
          ))}
          <div>
            {(() => {
              const bidMaterial = record.bid_rfq_site_details;
              const materialDetails = bidMaterial.flatMap(
                (site) => site.bid_rfq_material_details
              );

              const sum = materialDetails.reduce((acc, material) => {
                return acc + (parseFloat(material.amount_with_gst) || 0);
              }, 0);

              return (
                <Input disabled value={sum.toFixed(0)} className="InputItem" />
              );
            })()}
          </div>
        </div>
      ),
    },
    {
      title: "Amount Without GST",
      dataIndex: "amount_without_gst",
      key: "amount_without_gst",
      render: (text, record) => (
        <div>
          {record.bid_rfq_site_details.map((site) => (
            <div key={site?.site_id}></div>
          ))}
          <div>
            {(() => {
              const bidMaterial = record.bid_rfq_site_details;
              const materialDetails = bidMaterial.flatMap(
                (site) => site.bid_rfq_material_details
              );

              const sum = materialDetails.reduce((acc, material) => {
                return acc + (parseFloat(material.amount_without_gst) || 0);
              }, 0);

              return (
                <Input disabled value={sum.toFixed(0)} className="InputItem" />
              );
            })()}
          </div>
        </div>
      ),
    },
  ];

  const getColumns3 = () => {
    const columns3 = [
      {
        title: "City",
        dataIndex: "city",
        key: "city",
        width: 120,
        fixed: "left",
        render: (city, record, rowIndex) => {
          const data = summaryTableData;
          if (rowIndex === 0 || city !== data[rowIndex - 1].city) {
            return <div>{city}</div>;
          }
          return null;
        },
      },
      {
        title: "Site",
        dataIndex: "site",
        key: "site",
        width: 130,
        fixed: "left",
        render: (site, record) => {
          if (record.site === "Total") {
            return <div className="total3">Total</div>;
          }
          return <div>{site || "No site data"}</div>;
        },
      },
    ].filter(Boolean);
    
    if (revisedBidDates) {
      const R_col = currentStep >= 2 && {
        title: "R",
        children: [
          {
            title: "Amount Without GST",
            dataIndex: "totalAmountWithoutGstR",
            key: "amountWithoutGstR",
            width: 150,
            align: "right",
            render: (amount, record) => {
              if (record.site === "Total") {
                const total = record.totalAmountWithoutGstR || 0;
                return (
                  <div className="total3">
                    {`₹ ${total?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}`}
                  </div>
                );
              } else {
                const percentage = record.percentageWithoutGstR || "0";
                return (
                  <div>
                    {`₹ ${amount?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })} (${percentage}%)`}
                  </div>
                );
              }
            },
          },
          {
            title: "Amount With GST",
            dataIndex: "totalAmountWithGstR",
            key: "amountWithGstR",
            width: 150,
            align: "right",
            render: (amount, record) => {
              if (record.site === "Total") {
                const total = record.totalAmountWithGstR || 0;
                return (
                  <div className="total3">
                    {`₹ ${total?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}`}
                  </div>
                );
              } else {
                const percentage = record.percentageWithGstR || "0";
                return (
                  <div>
                    {`₹ ${amount?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })} (${percentage}%)`}
                  </div>
                );
              }
            },
          },
        ].filter(Boolean),
      };
      const R1_col = !hideR1 &&
        currentStep >= 1 && {
          title: "R1",
          children: [
            {
              title: "Amount Without GST",
              dataIndex: "totalAmountWithoutGstR1",
              key: "amountWithoutGstR1",
              width: 150,
              align: "right",
              render: (amount, record) => {
                if (record.site === "Total") {
                  const total = record.totalAmountWithoutGstR1 || 0;
                  return (
                    <div className="total3">
                      {`₹ ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                    </div>
                  );
                } else {
                  const percentage = record.percentageWithoutGstR1 || "0";
                  return (
                    <div>
                      {`₹ ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })} (${percentage}%)`}
                    </div>
                  );
                }
              },
            },
            {
              title: "Amount With GST",
              dataIndex: "totalAmountWithGstR1",
              key: "amountWithGstR1",
              width: 150,
              align: "right",
              render: (amount, record) => {
                if (record.site === "Total") {
                  const total = record.totalAmountWithGstR1 || 0;
                  return (
                    <div className="total3">
                      {`₹ ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                    </div>
                  );
                } else {
                  const percentage = record.percentageWithGstR1 || "0";
                  return (
                    <div>
                      {`₹ ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })} (${percentage}%)`}
                    </div>
                  );
                }
              },
            },
          ].filter(Boolean),
        };
      const R0_col = !hideR0 && {
        title: "R0",
        children: [
          {
            title: "Amount Without GST",
            dataIndex: "totalAmountWithoutGstR0",
            key: "amountWithoutGstR0",
            width: 150,
            align: "right",
            render: (amount, record) => {
              if (record.site === "Total") {
                const total = record.totalAmountWithoutGstR0 || 0;
                return (
                  <div className="total3">
                    {`₹ ${total?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}`}
                  </div>
                );
              } else {
                const percentage = record.percentageWithoutGstR0 || "0";
                return (
                  <div>
                    {`₹ ${amount?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })} (${percentage}%)`}
                  </div>
                );
              }
            },
          },
          {
            title: "Amount With GST",
            dataIndex: "totalAmountWithGstR0",
            key: "amountWithGstR0",
            width: 150,
            align: "right",
            render: (amount, record) => {
              if (record.site === "Total") {
                const total = record.totalAmountWithGstR0 || 0;
                return (
                  <div className="total3">
                    {`₹ ${total?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })}`}
                  </div>
                );
              } else {
                const percentage = record.percentageWithGstR0 || "0";
                return (
                  <div>
                    {`₹ ${amount?.toLocaleString("en-IN", {
                      maximumFractionDigits: 0,
                    })} (${percentage}%)`}
                  </div>
                );
              }
            },
          },
        ].filter(Boolean),
      };
      if (R_col) columns3.push(R_col);
      if (R1_col) columns3.push(R1_col);
      if (R0_col) columns3.push(R0_col);
    } else {
      if (initialBidDates) {
        const R1_col = !hideR1 &&
          currentStep >= 1 && {
            title: "R1",
            children: [
              {
                title: "Amount Without GST",
                dataIndex: "totalAmountWithoutGstR1",
                key: "amountWithoutGstR1",
                width: 200,
                align: "right",
                render: (amount, record) => {
                  if (record.site === "Total") {
                    const total = record.totalAmountWithoutGstR1 || 0;
                    return (
                      <div className="total3">
                        {`₹ ${total?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })}`}
                      </div>
                    );
                  } else {
                    const percentage = record.percentageWithoutGstR1 || "0";
                    return (
                      <div>
                        {`₹ ${amount?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })} (${percentage}%)`}
                      </div>
                    );
                  }
                },
              },
              {
                title: "Amount With GST",
                dataIndex: "totalAmountWithGstR1",
                key: "amountWithGstR1",
                width: 200,
                align: "right",
                render: (amount, record) => {
                  if (record.site === "Total") {
                    const total = record.totalAmountWithGstR1 || 0;
                    return (
                      <div className="total3">
                        {`₹ ${total?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })}`}
                      </div>
                    );
                  } else {
                    const percentage = record.percentageWithGstR1 || "0";
                    return (
                      <div>
                        {`₹ ${amount?.toLocaleString("en-IN", {
                          maximumFractionDigits: 0,
                        })} (${percentage}%)`}
                      </div>
                    );
                  }
                },
              },
            ].filter(Boolean),
          };
        const R0_col = !hideR0 && {
          title: "R0",
          children: [
            {
              title: "Amount Without GST",
              dataIndex: "totalAmountWithoutGstR0",
              key: "amountWithoutGstR0",
              width: 200,
              align: "right",
              render: (amount, record) => {
                if (record.site === "Total") {
                  const total = record.totalAmountWithoutGstR0 || 0;
                  return (
                    <div className="total3">
                      {`₹ ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                    </div>
                  );
                } else {
                  const percentage = record.percentageWithoutGstR0 || "0";
                  return (
                    <div>
                      {`₹ ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })} (${percentage}%)`}
                    </div>
                  );
                }
              },
            },
            {
              title: "Amount With GST",
              dataIndex: "totalAmountWithGstR0",
              key: "amountWithGstR0",
              width: 200,
              align: "right",
              render: (amount, record) => {
                if (record.site === "Total") {
                  const total = record.totalAmountWithGstR0 || 0;
                  return (
                    <div className="total3">
                      {`₹ ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                    </div>
                  );
                } else {
                  const percentage = record.percentageWithGstR0 || "0";
                  return (
                    <div>
                      {`₹ ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })} (${percentage}%)`}
                    </div>
                  );
                }
              },
            },
          ].filter(Boolean),
        };
        if (R1_col) columns3.push(R1_col);
        if (R0_col) columns3.push(R0_col);
      } else {
        const R0_col = !hideR0 && {
          title: "R0",
          children: [
            {
              title: "Amount Without GST",
              dataIndex: "totalAmountWithoutGstR0",
              key: "amountWithoutGstR0",
              width: 200,
              align: "right",
              render: (amount, record) => {
                if (record.site === "Total") {
                  const total = record.totalAmountWithoutGstR0 || 0;
                  return (
                    <div className="total3">
                      {`₹ ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                    </div>
                  );
                } else {
                  const percentage = record.percentageWithoutGstR0 || "0";
                  return (
                    <div>
                      {`₹ ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })} (${percentage}%)`}
                    </div>
                  );
                }
              },
            },
            {
              title: "Amount With GST",
              dataIndex: "totalAmountWithGstR0",
              key: "amountWithGstR0",
              width: 200,
              align: "right",
              render: (amount, record) => {
                if (record.site === "Total") {
                  const total = record.totalAmountWithGstR0 || 0;
                  return (
                    <div className="total3">
                      {`₹ ${total?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })}`}
                    </div>
                  );
                } else {
                  const percentage = record.percentageWithGstR0 || "0";
                  return (
                    <div>
                      {`₹ ${amount?.toLocaleString("en-IN", {
                        maximumFractionDigits: 0,
                      })} (${percentage}%)`}
                    </div>
                  );
                }
              },
            },
          ].filter(Boolean),
        };
        if (R0_col) columns3.push(R0_col);
      }
    }

    return columns3.map((col) => ({
      ...col,
      filterDropdown: col.filterDropdown || null,
    }));
  };
  const columns3 = getColumns3();
  useEffect(() => {
    // Map: city_name -> site_name -> siteData
    const cityMap = new Map();
    let totalWithGstR0 = 0,
      totalWithoutGstR0 = 0;
    let totalWithGstR1 = 0,
      totalWithoutGstR1 = 0;
    let totalWithGstR = 0,
      totalWithoutGstR = 0;
    // Declare these variables for the total row
    let totalAmountWithGstR0 = 0;
    let totalAmountWithoutGstR0 = 0;
    let totalAmountWithGstR1 = 0;
    let totalAmountWithoutGstR1 = 0;
    let totalAmountWithGstR = 0;
    let totalAmountWithoutGstR = 0;

    tableData.forEach((item) => {
      if (!item.site_name) return;
      const cityKey = item.city_name;
      const siteKey = item.site_name;

      // Use correct field names for each bid stage
      const unitRateR0 = parseFloat(item.initial_bid_price_unit_rate) || 0;
      const unitRateR0Freight =
        parseFloat(item.initial_bid_price_unit_rate_of_freight) || 0;
      const quantity = parseFloat(item.quantity) || 0;
      const gstRate = parseFloat(item.gst_rate) || 0;
      const gstRateFreight = parseFloat(item.gst_rate_freight) || 0;

      const amountWithoutGstR0 =
        unitRateR0 * quantity + unitRateR0Freight * quantity;
      const amountWithGstR0 =
        unitRateR0 * quantity * (1 + gstRate / 100) +
        unitRateR0Freight * quantity * (1 + gstRateFreight / 100);

      const unitRateR1 = parseFloat(item.revised_bid_price_unit_rate) || 0;
      const unitRateR1Freight =
        parseFloat(item.revised_bid_price_unit_rate_of_freight) || 0;
      const amountWithoutGstR1 =
        unitRateR1 * quantity + unitRateR1Freight * quantity;
      const amountWithGstR1 =
        unitRateR1 * quantity * (1 + gstRate / 100) +
        unitRateR1Freight * quantity * (1 + gstRateFreight / 100);

      const unitRateR = parseFloat(item.final_bid_price_unit_rate) || 0;
      const unitRateRFreight =
        parseFloat(item.final_bid_price_unit_rate_of_freight) || 0;
      const amountWithoutGstR =
        unitRateR * quantity + unitRateRFreight * quantity;
      const amountWithGstR =
        unitRateR * quantity * (1 + gstRate / 100) +
        unitRateRFreight * quantity * (1 + gstRateFreight / 100);

      // Get or create city
      if (!cityMap.has(cityKey)) {
        cityMap.set(cityKey, { city: cityKey, sites: new Map() });
      }
      const city = cityMap.get(cityKey);

      // Get or create site
      if (!city.sites.has(siteKey)) {
        city.sites.set(siteKey, {
          site: siteKey,
          totalAmountWithGstR0: 0,
          totalAmountWithoutGstR0: 0,
          totalAmountWithGstR1: 0,
          totalAmountWithoutGstR1: 0,
          totalAmountWithGstR: 0,
          totalAmountWithoutGstR: 0,
        });
      }
      const site = city.sites.get(siteKey);

      // Accumulate
      site.totalAmountWithGstR0 += amountWithGstR0;
      site.totalAmountWithoutGstR0 += amountWithoutGstR0;
      site.totalAmountWithGstR1 += amountWithGstR1;
      site.totalAmountWithoutGstR1 += amountWithoutGstR1;
      site.totalAmountWithGstR += amountWithGstR;
      site.totalAmountWithoutGstR += amountWithoutGstR;

      // Grand totals
      totalWithGstR0 += amountWithGstR0;
      totalWithoutGstR0 += amountWithoutGstR0;
      totalWithGstR1 += amountWithGstR1;
      totalWithoutGstR1 += amountWithoutGstR1;
      totalWithGstR += amountWithGstR;
      totalWithoutGstR += amountWithoutGstR;
      // For the total row variables
      totalAmountWithGstR0 += amountWithGstR0;
      totalAmountWithoutGstR0 += amountWithoutGstR0;
      totalAmountWithGstR1 += amountWithGstR1;
      totalAmountWithoutGstR1 += amountWithoutGstR1;
      totalAmountWithGstR += amountWithGstR;
      totalAmountWithoutGstR += amountWithoutGstR;
    });

    // Calculate percentages and build final array
    const finalData = [];
    cityMap.forEach((city) => {
      const citySites = [];
      city.sites.forEach((site) => {
        site.percentageWithoutGstR0 = totalWithoutGstR0
          ? ((site.totalAmountWithoutGstR0 / totalWithoutGstR0) * 100).toFixed(
              2
            )
          : 0;
        site.percentageWithGstR0 = totalWithGstR0
          ? ((site.totalAmountWithGstR0 / totalWithGstR0) * 100).toFixed(2)
          : 0;
        site.percentageWithoutGstR1 = totalWithoutGstR1
          ? ((site.totalAmountWithoutGstR1 / totalWithoutGstR1) * 100).toFixed(
              2
            )
          : 0;
        site.percentageWithGstR1 = totalWithGstR1
          ? ((site.totalAmountWithGstR1 / totalWithGstR1) * 100).toFixed(2)
          : 0;
        site.percentageWithoutGstR = totalWithoutGstR
          ? ((site.totalAmountWithoutGstR / totalWithoutGstR) * 100).toFixed(2)
          : 0;
        site.percentageWithGstR = totalWithGstR
          ? ((site.totalAmountWithGstR / totalWithGstR) * 100).toFixed(2)
          : 0;

        citySites.push(site);
        finalData.push({ city: city.city, ...site });
      });
      // finalData.push({ city: city.city, sites: citySites });
    });

    finalData.push({
      site: "Total",
      totalAmountWithGstR0,
      totalAmountWithoutGstR0,
      totalAmountWithGstR1,
      totalAmountWithoutGstR1,
      totalAmountWithGstR,
      totalAmountWithoutGstR,
    });

    setSummaryTableData(finalData);
  }, [tableData]);

  useEffect(() => {
    const materialTotals = {};
    const seenSubCategories = new Set();

    const sortedTableData = [...tableData].sort((a, b) =>
      (a.material_type_sub_category || "").localeCompare(b.material_type_sub_category || "")
    );

    sortedTableData.forEach((row) => {
      // const key = row.material_type_name;
       const key = `${row.material_type_name}|${row.material_type_sub_category || ""}`;
      if (!key) return;

      if (!materialTotals[key]) {
        const showSubCategory = !seenSubCategories.has(row.material_type_sub_category);
        seenSubCategories.add(row.material_type_sub_category);
        materialTotals[key] = {
          material_type_name: row.material_type_name,
          material_type_sub_category: showSubCategory ? row.material_type_sub_category : "",
          total_quantity: 0,
          total_cost: 0,
          uom: row.material_wise_uom || "MT",
          sizeGroups: {},
        };
      }

      // Convert quantity to MT
      let qtyMT = 0;
      if ((row.material_wise_uom || "MT") === "KG") {
        qtyMT = (row.quantity || 0) / 1000;
      } else {
        qtyMT = row.quantity || 0;
      }

      const size = row.diameter || "Unknown Size";

      // Normalize price to per MT
      const unitRate = Number(row.initial_bid_price_unit_rate || 0);
      const freightRate = Number(
        row.initial_bid_price_unit_rate_of_freight || 0
      );

      let pricePerMT = 0;
      if ((row.material_wise_uom || "MT") === "KG") {
        pricePerMT = (unitRate + freightRate) * 1000;
      } else {
        pricePerMT = unitRate + freightRate;
      }

      // Initialize size group if needed
      if (!materialTotals[key].sizeGroups[size]) {
        materialTotals[key].sizeGroups[size] = {
          total_quantity: 0,
          total_cost: 0,
        };
      }

      // Add to totals
      materialTotals[key].sizeGroups[size].total_quantity += qtyMT;
      materialTotals[key].sizeGroups[size].total_cost += pricePerMT * qtyMT;
    });

    const fattenData = Object.values(materialTotals).map((material) => {
      const sizeGroups = material.sizeGroups;
      let totalCost = 0;
      let totalQty = 0;

      Object.values(sizeGroups).forEach(({ total_quantity, total_cost }) => {
        totalQty += total_quantity;
        totalCost += total_cost;
      });

      const averagePriceKG = totalQty ? totalCost / (totalQty * 1000) : 0;
      const averagePriceMT = averagePriceKG * 1000;

      return {
        material_type_name: material.material_type_name,
        material_type_sub_category: material.material_type_sub_category,
        total_quantity: totalQty,
        total_cost: totalCost,
        averagePriceKG,
        averagePriceMT,
        sizes: Object.entries(sizeGroups).map(([size, data]) => {
          const avgPriceKG = data.total_quantity
            ? data.total_cost / (data.total_quantity * 1000)
            : 0;
          return {
            size,
            total_quantity: data.total_quantity,
            total_cost: data.total_cost,
            averagePriceKG: avgPriceKG,
            averagePriceMT: avgPriceKG * 1000,
          };
        }),
      };
    });

    setSummaryTableData2(fattenData);
  }, [tableData]);

  useEffect(() => {
    const materialTotals = {};
const seenSubCategories = new Set();
    tableData.forEach((row) => {
      // const key = row.material_type_name;
      const key = `${row.material_type_name}|${row.material_type_sub_category || ""}`;
      if (!key) return;

      if (!materialTotals[key]) {
         const showSubCategory = !seenSubCategories.has(row.material_type_sub_category);
         seenSubCategories.add(row.material_type_sub_category);
        materialTotals[key] = {
          material_type_sub_category: showSubCategory ? row.material_type_sub_category : "",
          material_type_name: key,
          total_quantity: 0,
          total_cost: 0,
          uom: row.material_wise_uom || "MT",
          sizeGroups: {},
        };
      }

      // Convert quantity to MT
      let qtyMT = 0;
      if ((row.material_wise_uom || "MT") === "KG") {
        qtyMT = (row.quantity || 0) / 1000;
      } else {
        qtyMT = row.quantity || 0;
      }

      const size = row.diameter || "Unknown Size";

      // Normalize price to per MT
      const unitRate = Number(row.revised_bid_price_unit_rate || 0);
      const freightRate = Number(
        row.revised_bid_price_unit_rate_of_freight || 0
      );

      let pricePerMT = 0;
      if ((row.material_wise_uom || "MT") === "KG") {
        pricePerMT = (unitRate + freightRate) * 1000;
      } else {
        pricePerMT = unitRate + freightRate;
      }

      // Initialize size group if needed
      if (!materialTotals[key].sizeGroups[size]) {
        materialTotals[key].sizeGroups[size] = {
          total_quantity: 0,
          total_cost: 0,
        };
      }

      // Add to totals
      materialTotals[key].sizeGroups[size].total_quantity += qtyMT;
      materialTotals[key].sizeGroups[size].total_cost += pricePerMT * qtyMT;
    });

    const fattenData = Object.values(materialTotals).map((material) => {
      const sizeGroups = material.sizeGroups;
      let totalCost = 0;
      let totalQty = 0;

      Object.values(sizeGroups).forEach(({ total_quantity, total_cost }) => {
        totalQty += total_quantity;
        totalCost += total_cost;
      });

      const averagePriceKG = totalQty ? totalCost / (totalQty * 1000) : 0;
      const averagePriceMT = averagePriceKG * 1000;

      return {
        material_type_name: material.material_type_name,
        material_type_sub_category: material.material_type_sub_category,
        total_quantity: totalQty,
        total_cost: totalCost,
        averagePriceKG,
        averagePriceMT,
        sizes: Object.entries(sizeGroups).map(([size, data]) => {
          const avgPriceKG = data.total_quantity
            ? data.total_cost / (data.total_quantity * 1000)
            : 0;
          return {
            size,
            total_quantity: data.total_quantity,
            total_cost: data.total_cost,
            averagePriceKG: avgPriceKG,
            averagePriceMT: avgPriceKG * 1000,
          };
        }),
      };
    });

    setSummaryTableDataRevised(fattenData);
  }, [tableData]);

  useEffect(() => {
    const materialTotals = {};
    const seenSubCategories = new Set();
    tableData.forEach((row) => {
      // const key = row.material_type_name;
      const key = `${row.material_type_name}|${row.material_type_sub_category || ""}`;
      if (!key) return;

      if (!materialTotals[key]) {
        const showSubCategory = !seenSubCategories.has(row.material_type_sub_category);
         seenSubCategories.add(row.material_type_sub_category);
        materialTotals[key] = {
          material_type_sub_category: showSubCategory ? row.material_type_sub_category : "",
          material_type_name: key,
          total_quantity: 0,
          total_cost: 0,
          uom: row.material_wise_uom || "MT",
          sizeGroups: {},
        };
      }

      // Convert quantity to MT
      let qtyMT = 0;
      if ((row.material_wise_uom || "MT") === "KG") {
        qtyMT = (row.quantity || 0) / 1000;
      } else {
        qtyMT = row.quantity || 0;
      }

      const size = row.diameter || "Unknown Size";

      // Normalize price to per MT
      const unitRate = Number(row.final_bid_price_unit_rate || 0);
      const freightRate = Number(row.final_bid_price_unit_rate_of_freight || 0);

      let pricePerMT = 0;
      if ((row.material_wise_uom || "MT") === "KG") {
        pricePerMT = (unitRate + freightRate) * 1000;
      } else {
        pricePerMT = unitRate + freightRate;
      }

      // Initialize size group if needed
      if (!materialTotals[key].sizeGroups[size]) {
        materialTotals[key].sizeGroups[size] = {
          total_quantity: 0,
          total_cost: 0,
        };
      }

      // Add to totals
      materialTotals[key].sizeGroups[size].total_quantity += qtyMT;
      materialTotals[key].sizeGroups[size].total_cost += pricePerMT * qtyMT;
    });

    const fattenData = Object.values(materialTotals).map((material) => {
      const sizeGroups = material.sizeGroups;
      let totalCost = 0;
      let totalQty = 0;

      Object.values(sizeGroups).forEach(({ total_quantity, total_cost }) => {
        totalQty += total_quantity;
        totalCost += total_cost;
      });

      const averagePriceKG = totalQty ? totalCost / (totalQty * 1000) : 0;
      const averagePriceMT = averagePriceKG * 1000;

      return {
        material_type_name: material.material_type_name,
        material_type_sub_category: material.material_type_sub_category,
        total_quantity: totalQty,
        total_cost: totalCost,
        averagePriceKG,
        averagePriceMT,
        sizes: Object.entries(sizeGroups).map(([size, data]) => {
          const avgPriceKG = data.total_quantity
            ? data.total_cost / (data.total_quantity * 1000)
            : 0;
          return {
            size,
            total_quantity: data.total_quantity,
            total_cost: data.total_cost,
            averagePriceKG: avgPriceKG,
            averagePriceMT: avgPriceKG * 1000,
          };
        }),
      };
    });

    setSummaryTableDataFinal(fattenData);
  }, [tableData]);

  const columns4 = [
    {
      title: "R0 - Initial BID (without GST)",
      children: [
        {
          title: "Sub category",
          dataIndex: "material_type_sub_category",
          width: 140,
          render: (text) => {
            return text;
          },
        },
        {
          title: "Material Type",
          dataIndex: "material_type_name",
          key: "material_type_name",
          width: 130,
          render: (text, record) => {
            if (record.uom !== "Cubic Meter") {
              return <span>{text}</span>;
            }
          },
        },
        {
          title: "Average Price/MT",
          dataIndex: "averagePriceMT",
          key: "averagePriceMT",
          align: "right",
          render: (averagePriceMT) => {
            if (initialBidDates && isNaN(averagePriceMT)) {
              return "Not Quoted";
            } else {
              return averagePriceMT
                ? `₹ ${averagePriceMT.toFixed(2)} / MT`
                : `₹ 0`;
            }
          },
        },
        {
          title: "Average Price/KG",
          dataIndex: "averagePriceKG",
          key: "averagePriceKG",
          align: "right",
          render: (averagePriceKG) => {
            if (initialBidDates && isNaN(averagePriceKG)) {
              return "Not Quoted";
            } else {
              return averagePriceKG
                ? `₹ ${averagePriceKG.toFixed(2)} / KG`
                : `₹ 0`;
            }
          },
        },
      ],
    },
  ];

  const columns4Revised = [
    {
      title: "R1 - Revised BID (without GST)",
      children: [
        {
          title: "Sub category",
          dataIndex: "material_type_sub_category",
          width: 140,
          render: (text) => {
            return text;
          },
        },
        {
          title: "Material Type",
          dataIndex: "material_type_name",
          key: "material_type_name",
          width: 130,
          render: (text, record) => {
            if (record.uom !== "Cubic Meter") {
              return <span>{text}</span>;
            }
          },
        },
        {
          title: "Average Price/MT",
          dataIndex: "averagePriceMT",
          key: "averagePriceMT",
          align: "right",
          render: (averagePriceMT) => {
            if (initialBidDates && isNaN(averagePriceMT)) {
              return "Not Quoted";
            } else {
              return averagePriceMT
                ? `₹ ${averagePriceMT.toFixed(2)} / MT`
                : `₹ 0`;
            }
          },
        },
        {
          title: "Average Price/KG",
          dataIndex: "averagePriceKG",
          key: "averagePriceKG",
          align: "right",
          render: (averagePriceKG) => {
            if (initialBidDates && isNaN(averagePriceKG)) {
              return "Not Quoted";
            } else {
              return averagePriceKG
                ? `₹ ${averagePriceKG.toFixed(2)} / KG`
                : `₹ 0`;
            }
          },
        },
      ],
    },
  ];

  const columns4Final = [
    {
      title: "R - Final BID (without GST)",
      children: [
        {
          title: "Sub category",
          dataIndex: "material_type_sub_category",
          width: 140,
          render: (text) => {
            return text;
          },
        },
        {
          title: "Material Type",
          dataIndex: "material_type_name",
          key: "material_type_name",
          width: 130,
        },
        {
          title: "Average Price/MT",
          dataIndex: "averagePriceMT",
          key: "averagePriceMT",
          align: "right",
          render: (averagePriceMT) => {
            if (finalBidDates && isNaN(averagePriceMT)) {
              return "Not Quoted";
            } else {
              return averagePriceMT
                ? `₹ ${averagePriceMT.toFixed(2)} / MT`
                : `₹ 0`;
            }
          },
        },
        {
          title: "Average Price/KG",
          dataIndex: "averagePriceKG",
          key: "averagePriceKG",
          align: "right",
          render: (averagePriceKG) => {
            if (finalBidDates && isNaN(averagePriceKG)) {
              return "Not Quoted";
            } else {
              return averagePriceKG
                ? `₹ ${averagePriceKG.toFixed(2)} / KG`
                : `₹ 0`;
            }
          },
        },
      ],
    },
  ];

  useEffect(() => {
    const amountsMap = {};

    tableData.forEach((item) => {
      if (item.siteId && item.material_type) {
        const key = `${item.siteId}-${item.material_type}`;

        const totalAmountWithoutGstR0 =
          ((parseFloat(item.initial_bid_price_unit_rate) || 0) +
            (parseFloat(item.initial_bid_price_unit_rate_of_freight) || 0)) *
          (parseFloat(item.material_total_quantity) || 0);
        const gstAmountR0 =
          totalAmountWithoutGstR0 * ((parseFloat(item.gst_rate) || 0) / 100);
        const totalAmountWithGstR0 = totalAmountWithoutGstR0 + gstAmountR0;

        const totalAmountWithoutGstR1 =
          ((parseFloat(item.revised_bid_price_unit_rate) || 0) +
            (parseFloat(item.revised_bid_price_unit_rate_of_freight) || 0)) *
          (parseFloat(item.material_total_quantity) || 0);
        const gstAmountR1 =
          totalAmountWithoutGstR1 * ((parseFloat(item.gst_rate) || 0) / 100);
        const totalAmountWithGstR1 = totalAmountWithoutGstR1 + gstAmountR1;

        const totalAmountWithoutGstR =
          ((parseFloat(item.final_bid_price_unit_rate) || 0) +
            (parseFloat(item.final_bid_price_unit_rate_of_freight) || 0)) *
          (parseFloat(item.material_total_quantity) || 0);
        const gstAmountR =
          totalAmountWithoutGstR * ((parseFloat(item.gst_rate) || 0) / 100);
        const totalAmountWithGstR = totalAmountWithoutGstR + gstAmountR;

        if (!amountsMap[key]) {
          amountsMap[key] = {
            totalAmountWithGstR0: 0,
            totalAmountWithoutGstR0: 0,
            totalAmountWithGstR1: 0,
            totalAmountWithoutGstR1: 0,
            totalAmountWithGstR: 0,
            totalAmountWithoutGstR: 0,
          };
        }

        amountsMap[key].totalAmountWithGstR0 += totalAmountWithGstR0;
        amountsMap[key].totalAmountWithoutGstR0 += totalAmountWithoutGstR0;

        amountsMap[key].totalAmountWithGstR1 += totalAmountWithGstR1;
        amountsMap[key].totalAmountWithoutGstR1 += totalAmountWithoutGstR1;

        amountsMap[key].totalAmountWithGstR += totalAmountWithGstR;
        amountsMap[key].totalAmountWithoutGstR += totalAmountWithoutGstR;
      }
    });

    setAmountsBySiteAndMaterial(amountsMap);
  }, [tableData]);

  const handleCheckboxChange = (e) => {
    const value = e.target.checked;
    setIsFinalBid(value);

    setState((prevState) => ({
      ...prevState,
      is_final_bid_price: value,
    }));

    if (initialBidDates) {
      setIsFinalWhen({
        ...isFinalWhen,
        isFinalR1: true,
      });
    } else if (!initialBidDates) {
      setIsFinalWhen({
        ...isFinalWhen,
        isFinalR0: true,
      });
    }
  };
  const resetUnitRateWithGst = (item) => {
    item.bid_rfq_site_details.forEach((site) => {
      site.bid_rfq_material_details.forEach((material) => {
        material.unit_rate_with_gst = null;
      });
    });
    return item;
  };

  const handleBidSubmission = () => {
    confirmAlert({
      title: "Confirm",
      message: isFinalBid ? (
        "Are you sure that you want to submit final no regret price as you will not able to modify the BID subsequently?"
      ) : revisedBidDates ? (
        `Are you sure you want to Submit BID ?`
      ) : (
        <>
          Are you sure you want to Submit BID ?<br />
          <span
            style={{
              color: "red",
              fontSize: "11px",
              fontWeight: "bold",
              padding: "20px",
            }}
          >
            Note: If the final BID is not submitted, the current BID will be
            considered as final.
          </span>
        </>
      ),
      buttons: [
        {
          label: "Yes",
          width: "90px",
          style: {
            backgroundColor: "#094e8f",
            color: "#fff",
            borderRadius: "4px",
            fontSize: "16px",
          },
          onClick: () => {
            if (currentStep === 0) {
              handleSubmit();
              resetGSTValues();
            } else if (currentStep === 1) {
              handleSubPatch();
              resetGSTValues();
            } else {
              handleSubPatch();
              resetGSTValues();
            }
          },
        },
        {
          label: "No",
          width: "90px",
          style: {
            backgroundColor: "#d9d9d9",
            color: "#000",
            borderRadius: "4px",
            fontSize: "16px",
          },
        },
      ],
    });
  };

  useEffect(() => {
    if (currentStep === 3) {
      navigate(`/rfq-vendor-request-for-quotation/history/1`);
    }
  }, [currentStep, CategoryId]);

  let hasBidDate = null;

  if (revisedBidDates) {
    hasBidDate = tableData
      .filter((i) => i.siteName !== "Sub-Total" && i.siteName !== "City-Total")
      .every((item) => item.final_bid_price_unit_rate === 0);
  } else if (initialBidDates) {
    hasBidDate = tableData
      .filter((i) => i.siteName !== "Sub-Total" && i.siteName !== "City-Total")
      .every((item) => item.revised_bid_price_unit_rate === 0);
  } else {
    hasBidDate = tableData
      .filter((i) => i.siteName !== "Sub-Total" && i.siteName !== "City-Total")
      .every((item) =>
        finalBidDates
          ? item.final_bid_price_unit_rate === 0
          : revisedBidDates
          ? item.revised_bid_price_unit_rate === 0
          : item.initial_bid_price_unit_rate === 0
      );
  }

  // const isSubmitDisabled = tableData
  //   .filter((i) => i.siteName !== "Sub-Total" && i.siteName !== "City-Total")
  //   .every((item) =>
  //     finalBidDates
  //       ? item.final_bid_price_unit_rate === 0
  //       : revisedBidDates
  //       ? item.revised_bid_price_unit_rate === 0
  //       : item.initial_bid_price_unit_rate === 0
  //   );

  const isSubmitDisabled = hasBidDate;

  const handleSubmit = async () => {
    const currentDate = (() => {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    })();

    const updatedTableData = tableData.map((item) => {
      if (!item.isSubtotal && item.material_type_name) {
        return {
          ...item,
          initial_bid_price_date: currentDate,
          revised_bid_price_date: currentDate,
          final_bid_price_date: currentDate,
        };
      }
      return item;
    });

    setTableData(updatedTableData);

    const payload = buildPayloadFromTableData(
      updatedTableData,
      VendorId,
      isFinalBid,
      buyingPatternPayload
    );

    try {
      setLoading(true);
      let response;
      response = await patchRequest(
        `bid-rfq/${vendorBidId}/create-bid-rfq/`,
        payload
      );

      if (response.data.success) {
        setLoading(false);
        navigate(`/rfq-vendor-request-for-quotation/history/1`);
        setCurrentStep(currentStep + 1);

        if (isFinalBid) {
          SuccessNotificationMsg(t("Final BID Submitted"));
        } else {
          if (currentStep === 0) {
            SuccessNotificationMsg(t("bidding_of_R0"));
          }
        }
        if (isFinalBid) {
          navigate(`/rfq-vendor-request-for-quotation/history/1`);
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleSubPatch = async () => {
    const currentDate = (() => {
      const today = new Date();
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    })();

    const updatedTableData = tableData.map((item) => {
      if (!item.isSubtotal && item.material_type_name) {
        return {
          ...item,
          initial_bid_price_date: currentDate,
          revised_bid_price_date: currentDate,
          final_bid_price_date: currentDate,
        };
      }
      return item;
    });

    setTableData(updatedTableData);

    // Build nested payload using the new utility
    const payload = buildPayloadFromTableData(
      updatedTableData,
      VendorId,
      isFinalBid,
      buyingPatternPayload
    );

    try {
      setLoading(true);
      let response;
      response = await patchRequest(`bid-rfq/${vendorBidId}/`, payload);
      if (response.data.success) {
        setLoading(false);
        setCurrentStep(currentStep + 1);
        setBuyingPatternPayload(response.data.data.bid_buying_pattern);
        if (currentStep === 0) {
          SuccessNotificationMsg(t("bidding_of_R0"));
        } else if (currentStep === 1) {
          navigate(`/rfq-vendor-request-for-quotation/history/1`);

          if (isFinalBid) {
            SuccessNotificationMsg(t("Final BID Submitted"));
          } else {
            SuccessNotificationMsg(t("bidding_of_R1"));
          }
        } else {
          navigate(`/rfq-vendor-request-for-quotation/history/1`);
          if (isFinalBid) {
            SuccessNotificationMsg(t("Final BID Submitted"));
          } else {
            SuccessNotificationMsg(t("bidding_of_R"));
          }
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const transformedData = {
    companyName: rfqDetails.company,
    rfqnumber: rfqDetails.rfq_number,
    rfqcurrency: rfqDetails.currency_name,
    rfqpricebasis: rfqDetails.price_basis,
    rfqfreight: rfqDetails.freight,
    rfqunloading: rfqDetails.unloading,
    rfqtransportInsurance: rfqDetails.transport_insurance,
    rfqduedate: rfqDetails.rfq_due_date,
    rfqopendeliverydate: rfqDetails.delivery_date,
    rfqamountcap: rfqDetails.amount_cap || "N/A",
    rfqtimelinecap: rfqDetails.open_order ? "Timeline Cap Data" : "N/A",
    rfqdeliverystartdate: rfqDetails.delivery_start_date || "N/A",
    rfqdeliveryenddate: rfqDetails.delivery_end_date || "N/A",
    open_order: rfqDetails.open_order,
  };

  const columns1 = [
    {
      title: "Company Name",
      dataIndex: "companyName",
      key: "companyName",
    },
    {
      title: "RFQ Number",
      dataIndex: "rfqnumber",
      key: "rfqnumber",
    },
    {
      title: "Currency",
      dataIndex: "rfqcurrency",
      key: "rfqcurrency",
    },
    {
      title: "Price Basis",
      dataIndex: "rfqpricebasis",
      key: "rfqpricebasis",
    },
    {
      title: "Freight",
      dataIndex: "rfqfreight",
      key: "rfqfreight",
    },
    {
      title: "Transport Insurance",
      dataIndex: "rfqtransportInsurance",
      key: "rfqtransportInsurance",
    },
    {
      title: "Unloading",
      dataIndex: "rfqunloading",
      key: "rfqunloading",
    },

    {
      title: "RFQ Due Date",
      dataIndex: "rfqduedate",
      key: "rfqduedate",
    },
    !rfqData.open_order && {
      title: "Delivery Date",
      dataIndex: "rfqopendeliverydate",
      key: "rfqopendeliverydate",
      render: (text, record) =>
        record.open_order ? "N/A" : record.rfqopendeliverydate,
    },
    rfqData.open_order && {
      title: "Amount Cap",
      dataIndex: "rfqamountcap",
      key: "rfqamountcap",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
    rfqData.open_order && {
      title: "Delivery Start Date",
      dataIndex: "rfqdeliverystartdate",
      key: "rfqdeliverystartdate",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
    rfqData.open_order && {
      title: "Delivery End Date",
      dataIndex: "rfqdeliveryenddate",
      key: "rfqdeliveryenddate",
      render: (text, record) => (record.open_order ? text : "N/A"),
    },
  ].filter(Boolean);

  // When you receive the API response, flatten the data:
  // useEffect(() => {
  //   if (rfqDetails && rfqDetails.bid_rfq_city_wise_detail) {
  //     setTableData(flattenBidDataForTable(rfqDetails));
  //   }
  // }, [rfqDetails]);

  const handleDiameterUnitRateChange = (value, row) => {
    setTableData((prev) =>
      prev.map((r) =>
        r.siteId === row.siteId &&
        r.material_type === row.material_type &&
        r.diameter === row.diameter
          ? { ...r, unit_rate: value }
          : r
      )
    );
  };
  const groupedColumns = [
    {
      title: "Sr.",
      dataIndex: "sr",
      width: 50,
      render: (text, row, index) => {
        if (
          index === 0 ||
          tableData[index].city_name !== tableData[index - 1].city_name
        ) {
          return text;
        }
        return "";
      },
    },
    {
      title: "City",
      dataIndex: "city_name",
      width: 100,
      render: (text, row, index) => {
        if (
          index === 0 ||
          tableData[index].city_name !== tableData[index - 1].city_name
        ) {
          return text;
        }
        return "";
      },
    },
    {
      title: "Site",
      dataIndex: "site_name",
      width: 120,
      render: (text, row, index) => {
        if (
          index === 0 ||
          tableData[index].site_name !== tableData[index - 1].site_name ||
          tableData[index].city_name !== tableData[index - 1].city_name
        ) {
          return text;
        }
        return "";
      },
    },
    {
      title: "Sub category",
      dataIndex: "material_type_sub_category",
      key: "material_type_sub_category",
      width: 120,
    },
    {
      title: "Material Type",
      dataIndex: "material_type_name",
      width: 160,
      render: (text, row, index) => {
        if (
          index === 0 ||
          tableData[index].material_type_name !==
            tableData[index - 1].material_type_name ||
          tableData[index].site_name !== tableData[index - 1].site_name ||
          tableData[index].city_name !== tableData[index - 1].city_name
        ) {
          return text;
        }
        return "";
      },
    },
    {
      title: "Diameter",
      dataIndex: "diameter",
      width: 80,
      render: (text, row) =>
        text ? `${text} ${(row.diameter_uom || "").toUpperCase()}`.trim() : "",
    },
    {
      title: "Qty.",
      dataIndex: "quantity",
      width: 60,
    },
    {
      title: "UoM.",
      dataIndex: "material_wise_uom",
      key: "material_wise_uom",
      width: 70,
      render: (text) => text,
    },
    revisedBidDates !== null && {
      title: `R (Without GST)${
        finalBidDates ? " (" + finalBidDates + ")" : ""
      }`,
      children: [
        {
          title: "Unit Rate",
          dataIndex: "final_bid_price_unit_rate",
          align: "right",
          width: "120px",
          render: (text, row) => {
            if (finalBidDates) {
              return <span>{text === 0 ? "N/A" : `₹ ${text}`}</span>;
            } else {
              return (
                <Input
                  value={row.final_bid_price_unit_rate || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                      handleGroupedUnitRateChange(
                        e.target.value,
                        row,
                        "final_bid_price_unit_rate"
                      )
                      }
                  }
                  }
                  maxLength={5}
                  placeholder="0"
                  style={{ width: 80 }}
                  prefix={<RupeesSign />}
                />
              );
            }
          },
        },
        showUnitRateOfFreight && {
          title: "Unit Rate Freight",
          dataIndex: "final_bid_price_unit_rate_of_freight",
          key: "final_bid_price_unit_rate_of_freight",
          align: "right",
          width: "100px",
          render: (text, row) => {
            const isDisabled =
              row?.siteName === "Sub-Total" || row?.siteName === "City-Total";

            if (finalBidDates) {
              return <span>{text === 0 ? "N/A" : `₹ ${text}`}</span>;
            } else {
              return (
                <div>
                  {isDisabled ? (
                    <div style={{ marginLeft: "1px" }}></div>
                  ) : (
                    <Input
                      name={`final_bid_price_unit_rate_of_freight_${row.material_type}`}
                      value={row.final_bid_price_unit_rate_of_freight || ""}
                      prefix={<RupeesSign />}
                      maxLength={5}
                      placeholder="0"
                      onChange={(e) => {
                        const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        handleGroupedUnitRateChange(
                          e.target.value,
                          row,
                          "final_bid_price_unit_rate_of_freight"
                        );
                      }
                      }}
                      style={{ width: "80px" }}
                    />
                  )}
                </div>
              );
            }
          },
        },
        {
          title: "Amount",
          dataIndex: "r_amount",
          width: "130px",
          align: "right",
          render: (text, row) => {
            const val =
              (parseFloat(row.final_bid_price_unit_rate || 0) +
                parseFloat(row.final_bid_price_unit_rate_of_freight || 0)) *
              parseFloat(row.quantity || 0);
            return `₹ ${val.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
            })}`;
          },
        },
        {
          title: "Unit Rate With GST",
          dataIndex: "r_unit_rate_with_gst",
          width: "130px",
          align: "right",
          render: (text, row) => {
            const val =
              parseFloat(row.final_bid_price_unit_rate || 0) *
                (1 + (row.gst_rate || 0) / 100) +
              parseFloat(row.final_bid_price_unit_rate_of_freight || 0) *
                (1 + (row.gst_rate_freight || 0) / 100);
            return `₹ ${val.toFixed(2)}`;
          },
        },
      ].filter(Boolean),
    },
    !hideR1 &&
      initialBidDates !== null && {
        title: `R1 (Without GST)${
          revisedBidDates ? " (" + revisedBidDates + ")" : ""
        }`,
        children: [
          {
            title: "Unit Rate",
            dataIndex: "revised_bid_price_unit_rate",
            align: "right",
            width: "120px",
            render: (text, row) => {
              if (revisedBidDates) {
                return <span>{text === 0 ? "N/A" : `₹ ${text}`}</span>;
              } else {
                return (
                  <Input
                    value={row.revised_bid_price_unit_rate || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                          handleGroupedUnitRateChange(
                            e.target.value,
                            row,
                            "revised_bid_price_unit_rate"
                          )

                      }}
                    }
                    maxLength={5}
                    style={{ width: 80 }}
                    prefix={<RupeesSign />}
                    placeholder="0"
                  />
                );
              }
            },
          },
          showUnitRateOfFreight && {
            title: "Unit Rate Freight",
            dataIndex: "revised_bid_price_unit_rate_of_freight",
            key: "revised_bid_price_unit_rate_of_freight",
            align: "right",
            width: "100px",
            render: (text, row) => {
              const isDisabled =
                row?.siteName === "Sub-Total" || row?.siteName === "City-Total";

              if (revisedBidDates) {
                return <span>{text === 0 ? "N/A" : `₹ ${text}`}</span>;
              } else {
                return (
                  <div>
                    {isDisabled ? (
                      <div style={{ marginLeft: "1px" }}></div>
                    ) : (
                      <Input
                        name={`revised_bid_price_unit_rate_of_freight_${row.material_type}`}
                        value={row.revised_bid_price_unit_rate_of_freight || ""}
                        prefix={<RupeesSign />}
                        maxLength={5}
                        placeholder="0"
                        onChange={(e) => {
                          const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                          handleGroupedUnitRateChange(
                            e.target.value,
                            row,
                            "revised_bid_price_unit_rate_of_freight"
                          );
                      }
                        }}
                        style={{ width: "80px" }}
                      />
                    )}
                  </div>
                );
              }
            },
          },
          {
            title: "Amount",
            dataIndex: "r1_amount",
            width: "130px",
            align: "right",
            render: (text, row) => {
              const val =
                (parseFloat(row.revised_bid_price_unit_rate || 0) +
                  parseFloat(row.revised_bid_price_unit_rate_of_freight || 0)) *
                parseFloat(row.quantity || 0);
              return `₹ ${val.toLocaleString("en-IN", {
                maximumFractionDigits: 2,
              })}`;
            },
          },
          {
            title: "Unit Rate With GST",
            dataIndex: "r1_unit_rate_with_gst",
            width: "130px",
            align: "right",
            render: (text, row) => {
              const val =
                parseFloat(row.revised_bid_price_unit_rate || 0) *
                  (1 + (row.gst_rate || 0) / 100) +
                parseFloat(row.revised_bid_price_unit_rate_of_freight || 0) *
                  (1 + (row.gst_rate_freight || 0) / 100);
              return `₹ ${val.toFixed(2)}`;
            },
          },
        ].filter(Boolean),
      },

    !hideR0 && {
      title: `R0 (Without GST)${
        initialBidDates ? " (" + initialBidDates + ")" : ""
      }`,
      children: [
        {
          title: "Unit Rate",
          dataIndex: "initial_bid_price_unit_rate",
          align: "right",
          width: "95px",
          render: (text, row) => {
            if (initialBidDates) {
              // return <span>₹ {text || ""}</span>;
              return <span>{text === 0 ? "N/A" : `₹ ${text}`}</span>;
            } else {
              return (
                <Input
                  placeholder="0"
                  value={row.initial_bid_price_unit_rate || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                    handleGroupedUnitRateChange(
                      e.target.value,
                      row,
                      "initial_bid_price_unit_rate"
                    )
                      }
                  }
                  }
                  style={{ width: 80 }}
                  prefix={<RupeesSign />}
                  maxLength={5}
                />
              );
            }
          },
        },
        showUnitRateOfFreight && {
          title: "Unit Rate Freight",
          dataIndex: "initial_bid_price_unit_rate_of_freight",
          key: "initial_bid_price_unit_rate_of_freight",
          align: "right",
          width: "100px",
          render: (text, row) => {
            const isDisabled =
              row?.siteName === "Sub-Total" || row?.siteName === "City-Total";

            if (initialBidDates) {
              // return <span>₹ {text || ""}</span>;
              return <span>{text === 0 ? "N/A" : `₹ ${text}`}</span>;
            } else {
              return (
                <div>
                  {isDisabled ? (
                    <div style={{ marginLeft: "1px" }}></div>
                  ) : (
                    <Input
                      name={`initial_bid_price_unit_rate_of_freight_${row.material_type}`}
                      placeholder="0"
                      value={row.initial_bid_price_unit_rate_of_freight || ""}
                      prefix={<RupeesSign />}
                      maxLength={5}
                      onChange={(e) => {
                        const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        handleGroupedUnitRateChange(
                          e.target.value,
                          row,
                          "initial_bid_price_unit_rate_of_freight"
                        );
                      }
                      }}
                      style={{ width: "80px" }}
                    />
                  )}
                </div>
              );
            }
          },
        },
        {
          title: "Amount",
          dataIndex: "r0_amount",
          width: "110px",
          align: "right",
          render: (text, row) => {
            const val =
              (parseFloat(row.initial_bid_price_unit_rate || 0) +
                parseFloat(row.initial_bid_price_unit_rate_of_freight || 0)) *
              parseFloat(row.quantity || 0);
            return `₹ ${val.toLocaleString("en-IN", {
              maximumFractionDigits: 2,
            })}`;
          },
        },
        {
          title: "Unit Rate With GST",
          dataIndex: "r0_unit_rate_with_gst",
          width: "100px",
          align: "right",
          render: (text, row) => {
            const val =
              parseFloat(row.initial_bid_price_unit_rate || 0) *
                (1 + (row.gst_rate || 0) / 100) +
              parseFloat(row.initial_bid_price_unit_rate_of_freight || 0) *
                (1 + (row.gst_rate_freight || 0) / 100);
            return `₹ ${val.toFixed(2)}`;
          },
        },
      ].filter(Boolean),
    },
  ].filter(Boolean);

  const handleGroupedUnitRateChange = (value, row, field) => {
    setTableData((prev) =>
      prev.map((r) =>
        r.siteId === row.siteId &&
        r.material_type === row.material_type &&
        r.diameter === row.diameter
          ? { ...r, [field]: value }
          : r
      )
    );
  };
  

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename" style={{ whiteSpace: "nowrap" }}>
            <h3>BID RFQ - Vendor</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/rfq-vendor-request-for-quotation/history/1">
                  {t("RFQ History - Vendor")}
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>BID RFQ - Vendor</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              justifyContent: "flex-end",
            }}
          >
            <div className="dayfilter" style={{ color: "#094E8F" }}>
              <strong>Winning Ratio:</strong>
              <div
                className="rfq-number new"
                style={{ margin: "0", padding: "0" }}
              >
                {winningArray.map((item) => (
                  <Tooltip
                    key={item.key}
                    color="#094E8F"
                    placement="top"
                    title={`${item.value}%`}
                  >
                    <span>{item.key}</span>
                  </Tooltip>
                ))}
              </div>
            </div>
            <div className="dayfilter" style={{ color: "#094E8F" }}>
              <strong>Last 5 BID Result :</strong>
              <div
                className="rfq-number new"
                style={{ margin: "0", padding: "0" }}
              >
                {lastFiveBid?.map((bid, index) => {
                  let res = "";

                  if (bid === "Loose") {
                    res = "L";
                  } else if (bid === "N/A") {
                    res = "N/A";
                  } else {
                    res = "W";
                  }

                  if (index === 0) {
                    return (
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={"Latest"}
                        key={index}
                      >
                        <span>{res || ""}</span>
                      </Tooltip>
                    );
                  } else if (lastFiveBid.length - 1 === index) {
                    return (
                      <Tooltip
                        color="#094E8F"
                        placement="top"
                        title={"Earliest"}
                        key={index}
                      >
                        <span>{res || ""}</span>
                      </Tooltip>
                    );
                  } else {
                    return <span key={index}>{res || ""}</span>;
                  }
                })}
              </div>
            </div>
            <ButtonField
              type="primary"
              className="CancelGradiantBtn"
              htmlType="button"
              label={t("Back")}
              onClick={() =>
                navigate("/rfq-vendor-request-for-quotation/history/1")
              }
            />
          </div>
        </div>
      </div>
      <Content className="stepscontentwrap">
        <div className="stepsContent">
          <section className="grid-sec">
            <div className="PR-body" style={{ padding: "0px" }}>
              <div
                style={{
                  top: 0,
                  zIndex: 1000,
                  backgroundColor: "#fff",
                }}
              >
                <Collapse
                  defaultActiveKey={[0]}
                  key={0}
                  // className="custom-collapse"
                >
                  <Panel header={"RFQ Details"} key={0}>
                    <div style={{ marginTop: "10px" }}>
                      <Table
                        className="custom-head"
                        columns={columns1}
                        dataSource={[transformedData]}
                        pagination={false}
                        sticky
                      />
                    </div>
                  </Panel>
                </Collapse>
              </div>

              <div>
                <Form autoComplete="off" ref={formRef}>
                  <Spin spinning={apiLoading}>
                    <Table
                      columns={groupedColumns}
                      dataSource={tableData}
                      pagination={false}
                      bordered
                      scroll={{
                        x: 1000,
                      }}
                      sticky
                    />
                  </Spin>

                  <Row gutter={16} className="footerTablesContainer">
                    <Col
                      xs={24}
                      md={12}
                      className="footerTable3"
                      style={{ paddingTop: "16px" }}
                    >
                      {revisedBidDates !== null && (
                        <div style={{ maxWidth: "600px", overflowX: "auto" }}>
                          <Table
                            columns={columns4Final}
                            dataSource={summaryTableDataFinal}
                            pagination={false}
                            bordered
                            scroll={{
                              x: 500,
                            }}
                          />
                        </div>
                      )}
                      {!hideR1 && initialBidDates !== null && (
                        <div style={{ maxWidth: "600px", overflowX: "auto" }}>
                          <Table
                            columns={columns4Revised}
                            dataSource={summaryTableDataRevised}
                            pagination={false}
                            bordered
                            scroll={{
                              x: 500,
                            }}
                          />
                        </div>
                      )}
                      {!hideR0 && (
                        <div style={{ maxWidth: "600px", overflowX: "auto" }}>
                          <Table
                            columns={columns4}
                            dataSource={summaryTableData2}
                            pagination={false}
                            bordered
                            scroll={{
                              x: 400,
                            }}
                          />
                        </div>
                      )}
                    </Col>
                    <Col
                      xs={24}
                      md={12}
                      className="footerTable4"
                      style={{
                        paddingTop: "16px",
                        maxWidth: "900px",
                        overflowX: "auto",
                      }}
                    >
                      <Table
                        columns={columns3}
                        dataSource={summaryTableData}
                        pagination={false}
                        bordered
                        scroll={{
                          x: "auto",
                        }}
                      />
                    </Col>
                  </Row>

                  <div className="FormFooter">
                    {currentStep !== 2 && (
                      <Checkbox
                        checked={isFinalBid}
                        onChange={(e) => handleCheckboxChange(e)}
                      >
                        <span className="finalBid">
                          Is This Your Final Bid Price?
                        </span>
                      </Checkbox>
                    )}
                    {currentStep >= 1 && (
                      <>
                        <Checkbox
                          checked={hideR0}
                          onChange={handleHideR0Change}
                        >
                          Hide Initial BID Price - R0
                        </Checkbox>
                      </>
                    )}
                    {currentStep >= 2 && (
                      <>
                        <Checkbox
                          checked={hideR1}
                          onChange={handleHideR1Change}
                        >
                          Hide BID Price - R1
                        </Checkbox>
                      </>
                    )}
                  </div>
                </Form>
              </div>
            </div>
          </section>
        </div>
        <div
          className="FormFooter bidftr"
          style={{ padding: "16px", margin: "0" }}
        >
          <ButtonField
            type="primary"
            className="CancelGradiantBtn"
            htmlType="button"
            label={t("Back")}
            onClick={() =>
              navigate("/rfq-vendor-request-for-quotation/history/1")
            }
          />
          <ButtonField
            type="primary"
            className="SaveGradiantBtn"
            htmlType="button"
            label="Submit BID"
            onClick={handleBidSubmission}
            loading={loading}
            disabled={isSubmitDisabled}
          />
        </div>
      </Content>
    </>
  );
};

export default VendorBidRFQSteel;
